// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 10 6%27%3e %3cpath stroke=%27%236B7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m1 1 4 4 4-4%27/%3e %3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 12%27%3e %3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M1 5.917 5.724 10.5 15 1.5%27/%3e %3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg aria-hidden=%27true%27 xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 12%27%3e %3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M0.5 6h14%27/%3e %3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/bg/bg-section-2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/bg/4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/section-asset/asset-gif-3-mobile.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/bg/bg-section-5.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/bg/bg-section-6.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/laptopBG.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/mobileBG.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./assets/bg/bg-section-3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./assets/section-asset/asset-section-4-mobile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./assets/section-asset/asset-section-5-mobile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./assets/bg/bg-section-8.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./assets/section-asset/asset-section-4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./assets/section-asset/asset-section-5.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.2 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #E5E7EB; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Roboto, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9CA3AF; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

[data-tooltip-style^='light'] + .tooltip > .tooltip-arrow:before {
  border-style: solid;
  border-color: #e5e7eb;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='top'] > .tooltip-arrow:before {
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='right'] > .tooltip-arrow:before {
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='bottom'] > .tooltip-arrow:before {
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-tooltip-style^='light'] + .tooltip[data-popper-placement^='left'] > .tooltip-arrow:before {
  border-top-width: 1px;
  border-right-width: 1px;
}

.tooltip[data-popper-placement^='top'] > .tooltip-arrow {
  bottom: -4px;
}

.tooltip[data-popper-placement^='bottom'] > .tooltip-arrow {
  top: -4px;
}

.tooltip[data-popper-placement^='left'] > .tooltip-arrow {
  right: -4px;
}

.tooltip[data-popper-placement^='right'] > .tooltip-arrow {
  left: -4px;
}

.tooltip.invisible > .tooltip-arrow:before {
  visibility: hidden;
}

.tooltip.\\!invisible > .tooltip-arrow:before {
  visibility: hidden !important;
}

[data-popper-arrow],[data-popper-arrow]:before {
  position: absolute;
  width: 8px;
  height: 8px;
  background: inherit;
}

[data-popper-arrow] {
  visibility: hidden;
}

[data-popper-arrow]:before {
  content: "";
  visibility: visible;
  transform: rotate(45deg);
}

[data-popper-arrow]:after {
  content: "";
  visibility: visible;
  transform: rotate(45deg);
  position: absolute;
  width: 9px;
  height: 9px;
  background: inherit;
}

[role="tooltip"] > [data-popper-arrow]:before {
  border-style: solid;
  border-color: #e5e7eb;
}

.dark [role="tooltip"] > [data-popper-arrow]:before {
  border-style: solid;
  border-color: #4b5563;
}

[role="tooltip"] > [data-popper-arrow]:after {
  border-style: solid;
  border-color: #e5e7eb;
}

.dark [role="tooltip"] > [data-popper-arrow]:after {
  border-style: solid;
  border-color: #4b5563;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]:before {
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow]:after {
  border-bottom-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]:before {
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow]:after {
  border-bottom-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]:before {
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow]:after {
  border-top-width: 1px;
  border-left-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]:before {
  border-top-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow]:after {
  border-top-width: 1px;
  border-right-width: 1px;
}

[data-popover][role="tooltip"][data-popper-placement^='top'] > [data-popper-arrow] {
  bottom: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='bottom'] > [data-popper-arrow] {
  top: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='left'] > [data-popper-arrow] {
  right: -5px;
}

[data-popover][role="tooltip"][data-popper-placement^='right'] > [data-popper-arrow] {
  left: -5px;
}

[role="tooltip"].\\!invisible > [data-popper-arrow]:before {
  visibility: hidden !important;
}

[role="tooltip"].invisible > [data-popper-arrow]:before {
  visibility: hidden;
}

[role="tooltip"].\\!invisible > [data-popper-arrow]:after {
  visibility: hidden !important;
}

[role="tooltip"].invisible > [data-popper-arrow]:after {
  visibility: hidden;
}

[type='text'],[type='email'],[type='url'],[type='password'],[type='number'],[type='date'],[type='datetime-local'],[type='month'],[type='search'],[type='tel'],[type='time'],[type='week'],[multiple],textarea,select {
  appearance: none;
  background-color: #fff;
  border-color: #6B7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

[type='text']:focus, [type='email']:focus, [type='url']:focus, [type='password']:focus, [type='number']:focus, [type='date']:focus, [type='datetime-local']:focus, [type='month']:focus, [type='search']:focus, [type='tel']:focus, [type='time']:focus, [type='week']:focus, [multiple]:focus, textarea:focus, select:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #1C64F2;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #1C64F2;
}

input::placeholder,textarea::placeholder {
  color: #6B7280;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}

input[type="time"]::-webkit-calendar-picker-indicator {
  background: none;
}

select:not([size]) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.75rem center;
  background-repeat: no-repeat;
  background-size: 0.75em 0.75em;
  padding-right: 2.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

:is([dir=rtl]) select:not([size]) {
  background-position: left 0.75rem center;
  padding-right: 0.75rem;
  padding-left: 0;
}

[multiple] {
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  -webkit-print-color-adjust: unset;
          print-color-adjust: unset;
}

[type='checkbox'],[type='radio'] {
  appearance: none;
  padding: 0;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #1C64F2;
  background-color: #fff;
  border-color: #6B7280;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}

[type='checkbox'] {
  border-radius: 0px;
}

[type='radio'] {
  border-radius: 100%;
}

[type='checkbox']:focus,[type='radio']:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,/*!*/ /*!*/);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #1C64F2;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

[type='checkbox']:checked,[type='radio']:checked,.dark [type='checkbox']:checked,.dark [type='radio']:checked {
  border-color: transparent;
  background-color: currentColor;
  background-size: 0.55em 0.55em;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: 0.55em 0.55em;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

[type='radio']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 1em 1em;
}

.dark [type='radio']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: 1em 1em;
}

[type='checkbox']:indeterminate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-color: currentColor;
  border-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 0.55em 0.55em;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}

[type='checkbox']:indeterminate:hover,[type='checkbox']:indeterminate:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='file'] {
  background: unset;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: unset;
  line-height: inherit;
}

[type='file']:focus {
  outline: 1px auto inherit;
}

input[type=file]::file-selector-button {
  color: white;
  background: #1F2937;
  border: 0;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 2rem;
  padding-right: 1rem;
  margin-inline-start: -1rem;
  margin-inline-end: 1rem;
}

input[type=file]::file-selector-button:hover {
  background: #374151;
}

:is([dir=rtl]) input[type=file]::file-selector-button {
  padding-right: 2rem;
  padding-left: 1rem;
}

.dark input[type=file]::file-selector-button {
  color: white;
  background: #4B5563;
}

.dark input[type=file]::file-selector-button:hover {
  background: #6B7280;
}

input[type="range"]::-webkit-slider-thumb {
  height: 1.25rem;
  width: 1.25rem;
  background: #1C64F2;
  border-radius: 9999px;
  border: 0;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

input[type="range"]:disabled::-webkit-slider-thumb {
  background: #9CA3AF;
}

.dark input[type="range"]:disabled::-webkit-slider-thumb {
  background: #6B7280;
}

input[type="range"]:focus::-webkit-slider-thumb {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1px;
  --tw-ring-color: rgb(164 202 254 / var(--tw-ring-opacity));
}

input[type="range"]::-moz-range-thumb {
  height: 1.25rem;
  width: 1.25rem;
  background: #1C64F2;
  border-radius: 9999px;
  border: 0;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}

input[type="range"]:disabled::-moz-range-thumb {
  background: #9CA3AF;
}

.dark input[type="range"]:disabled::-moz-range-thumb {
  background: #6B7280;
}

input[type="range"]::-moz-range-progress {
  background: #3F83F8;
}

input[type="range"]::-ms-fill-lower {
  background: #3F83F8;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(63 131 248 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(63 131 248 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 320px) {

  .container {
    max-width: 320px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
@media (min-width: 2024px) {

  .container {
    max-width: 2024px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.\\!invisible {
  visibility: hidden !important;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.\\!absolute {
  position: absolute !important;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.-bottom-\\[50px\\] {
  bottom: -50px;
}
.-left-1 {
  left: -0.25rem;
}
.-left-1\\.5 {
  left: -0.375rem;
}
.-left-3 {
  left: -0.75rem;
}
.-right-1 {
  right: -0.25rem;
}
.-top-1 {
  top: -0.25rem;
}
.-top-1\\.5 {
  top: -0.375rem;
}
.-top-2 {
  top: -0.5rem;
}
.-top-2\\.5 {
  top: -0.625rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-16 {
  bottom: 4rem;
}
.bottom-4 {
  bottom: 1rem;
}
.bottom-5 {
  bottom: 1.25rem;
}
.bottom-\\[14\\%\\] {
  bottom: 14%;
}
.bottom-\\[4\\%\\] {
  bottom: 4%;
}
.end-2 {
  inset-inline-end: 0.5rem;
}
.end-2\\.5 {
  inset-inline-end: 0.625rem;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\.5 {
  left: 0.375rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.left-2\\.5 {
  left: 0.625rem;
}
.left-2\\/4 {
  left: 50%;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-5 {
  left: 1.25rem;
}
.left-6 {
  left: 1.5rem;
}
.left-\\[14\\%\\] {
  left: 14%;
}
.left-\\[2\\%\\] {
  left: 2%;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-2 {
  right: 0.5rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-\\[14\\%\\] {
  right: 14%;
}
.right-\\[2\\%\\] {
  right: 2%;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-10 {
  top: 2.5rem;
}
.top-2 {
  top: 0.5rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-2\\/4 {
  top: 50%;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-5 {
  top: 1.25rem;
}
.top-\\[14\\%\\] {
  top: 14%;
}
.top-\\[4\\%\\] {
  top: 4%;
}
.-z-10 {
  z-index: -10;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[2\\] {
  z-index: 2;
}
.z-\\[9995\\] {
  z-index: 9995;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.z-\\[999\\] {
  z-index: 999;
}
.z-auto {
  z-index: auto;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.-m-1 {
  margin: -0.25rem;
}
.-m-1\\.5 {
  margin: -0.375rem;
}
.m-0 {
  margin: 0px;
}
.m-0\\.5 {
  margin: 0.125rem;
}
.m-4 {
  margin: 1rem;
}
.m-auto {
  margin: auto;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.mx-px {
  margin-left: 1px;
  margin-right: 1px;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.-mb-4 {
  margin-bottom: -1rem;
}
.-mb-px {
  margin-bottom: -1px;
}
.-ml-1 {
  margin-left: -0.25rem;
}
.-mr-1 {
  margin-right: -0.25rem;
}
.-mt-2 {
  margin-top: -0.5rem;
}
.-mt-4 {
  margin-top: -1rem;
}
.-mt-5 {
  margin-top: -1.25rem;
}
.-mt-6 {
  margin-top: -1.5rem;
}
.-mt-8 {
  margin-top: -2rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.me-1 {
  margin-inline-end: 0.25rem;
}
.me-1\\.5 {
  margin-inline-end: 0.375rem;
}
.me-2 {
  margin-inline-end: 0.5rem;
}
.me-2\\.5 {
  margin-inline-end: 0.625rem;
}
.me-4 {
  margin-inline-end: 1rem;
}
.ml-0 {
  margin-left: 0px;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-5 {
  margin-left: 1.25rem;
}
.ml-6 {
  margin-left: 1.5rem;
}
.ml-\\[18px\\] {
  margin-left: 18px;
}
.ml-auto {
  margin-left: auto;
}
.mr-12 {
  margin-right: 3rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.ms-2 {
  margin-inline-start: 0.5rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-16 {
  margin-top: 4rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-\\[22px\\] {
  margin-top: 22px;
}
.mt-px {
  margin-top: 1px;
}
.box-border {
  box-sizing: border-box;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.\\!inline {
  display: inline !important;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-\\[3\\/1\\] {
  aspect-ratio: 3/1;
}
.h-0 {
  height: 0px;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-36 {
  height: 9rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-96 {
  height: 24rem;
}
.h-\\[100px\\] {
  height: 100px;
}
.h-\\[100vh\\] {
  height: 100vh;
}
.h-\\[10rem\\] {
  height: 10rem;
}
.h-\\[110px\\] {
  height: 110px;
}
.h-\\[26rem\\] {
  height: 26rem;
}
.h-\\[2rem\\] {
  height: 2rem;
}
.h-\\[30rem\\] {
  height: 30rem;
}
.h-\\[34px\\] {
  height: 34px;
}
.h-\\[4rem\\] {
  height: 4rem;
}
.h-\\[58px\\] {
  height: 58px;
}
.h-\\[74px\\] {
  height: 74px;
}
.h-auto {
  height: auto;
}
.h-fit {
  height: -moz-fit-content;
  height: fit-content;
}
.h-full {
  height: 100%;
}
.h-max {
  height: max-content;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-96 {
  max-height: 24rem;
}
.max-h-\\[100vh\\] {
  max-height: 100vh;
}
.max-h-\\[32px\\] {
  max-height: 32px;
}
.max-h-\\[40px\\] {
  max-height: 40px;
}
.max-h-\\[48px\\] {
  max-height: 48px;
}
.max-h-\\[90dvh\\] {
  max-height: 90dvh;
}
.min-h-\\[100px\\] {
  min-height: 100px;
}
.min-h-\\[100vh\\] {
  min-height: 100vh;
}
.min-h-\\[12px\\] {
  min-height: 12px;
}
.min-h-\\[24px\\] {
  min-height: 24px;
}
.min-h-\\[48px\\] {
  min-height: 48px;
}
.min-h-full {
  min-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.w-0 {
  width: 0px;
}
.w-0\\.5 {
  width: 0.125rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-1\\/4 {
  width: 25%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\/4 {
  width: 50%;
}
.w-2\\/5 {
  width: 40%;
}
.w-20 {
  width: 5rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-3\\/5 {
  width: 60%;
}
.w-32 {
  width: 8rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[100\\%\\] {
  width: 100%;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[100rem\\] {
  width: 100rem;
}
.w-\\[10rem\\] {
  width: 10rem;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[118px\\] {
  width: 118px;
}
.w-\\[130px\\] {
  width: 130px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[15rem\\] {
  width: 15rem;
}
.w-\\[18rem\\] {
  width: 18rem;
}
.w-\\[2\\.5rem\\] {
  width: 2.5rem;
}
.w-\\[2\\.8rem\\] {
  width: 2.8rem;
}
.w-\\[20rem\\] {
  width: 20rem;
}
.w-\\[22rem\\] {
  width: 22rem;
}
.w-\\[250px\\] {
  width: 250px;
}
.w-\\[280px\\] {
  width: 280px;
}
.w-\\[2rem\\] {
  width: 2rem;
}
.w-\\[30rem\\] {
  width: 30rem;
}
.w-\\[50rem\\] {
  width: 50rem;
}
.w-\\[58px\\] {
  width: 58px;
}
.w-\\[5rem\\] {
  width: 5rem;
}
.w-\\[6rem\\] {
  width: 6rem;
}
.w-\\[74px\\] {
  width: 74px;
}
.w-\\[8rem\\] {
  width: 8rem;
}
.w-auto {
  width: auto;
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-screen {
  width: 100vw;
}
.min-w-\\[100vw\\] {
  min-width: 100vw;
}
.min-w-\\[12px\\] {
  min-width: 12px;
}
.min-w-\\[180px\\] {
  min-width: 180px;
}
.min-w-\\[200px\\] {
  min-width: 200px;
}
.min-w-\\[240px\\] {
  min-width: 240px;
}
.min-w-\\[24px\\] {
  min-width: 24px;
}
.min-w-\\[48px\\] {
  min-width: 48px;
}
.min-w-\\[80\\%\\] {
  min-width: 80%;
}
.min-w-\\[90\\%\\] {
  min-width: 90%;
}
.min-w-\\[95\\%\\] {
  min-width: 95%;
}
.min-w-full {
  min-width: 100%;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[100vw\\] {
  max-width: 100vw;
}
.max-w-\\[1440px\\] {
  max-width: 1440px;
}
.max-w-\\[32px\\] {
  max-width: 32px;
}
.max-w-\\[40px\\] {
  max-width: 40px;
}
.max-w-\\[48px\\] {
  max-width: 48px;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-\\[95\\%\\] {
  max-width: 95%;
}
.max-w-full {
  max-width: 100%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-screen-2xl {
  max-width: 1536px;
}
.max-w-screen-xl {
  max-width: 1280px;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-none {
  flex: none;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.grow {
  flex-grow: 1;
}
.basis-full {
  flex-basis: 100%;
}
.origin-\\[0\\] {
  transform-origin: 0;
}
.origin-top-right {
  transform-origin: top right;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-2\\/4 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-0 {
  --tw-translate-y: -0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/4 {
  --tw-translate-y: -25%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-2\\/4 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-4 {
  --tw-translate-y: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-6 {
  --tw-translate-y: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-full {
  --tw-translate-y: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-2\\/4 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-2\\/4 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-full {
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0 {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-0 {
  --tw-scale-x: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-100 {
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform-none {
  transform: none;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-grab {
  cursor: grab;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-wait {
  cursor: wait;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.\\!resize-none {
  resize: none !important;
}
.resize-none {
  resize: none;
}
.resize-y {
  resize: vertical;
}
.\\!resize {
  resize: both !important;
}
.resize {
  resize: both;
}
.snap-x {
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}
.snap-mandatory {
  --tw-scroll-snap-strictness: mandatory;
}
.snap-center {
  scroll-snap-align: center;
}
.scroll-mt-10 {
  scroll-margin-top: 2.5rem;
}
.list-inside {
  list-style-position: inside;
}
.list-decimal {
  list-style-type: decimal;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  appearance: none;
}
.grid-flow-col {
  grid-auto-flow: column;
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-items-center {
  place-items: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-evenly {
  justify-content: space-evenly;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-20 {
  gap: 5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-\\[0rem\\] {
  gap: 0rem;
}
.gap-\\[1rem\\] {
  gap: 1rem;
}
.gap-\\[2rem\\] {
  gap: 2rem;
}
.gap-\\[3rem\\] {
  gap: 3rem;
}
.gap-x-1 {
  column-gap: 0.25rem;
}
.gap-x-1\\.5 {
  column-gap: 0.375rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.-space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-1rem * var(--tw-space-x-reverse));
  margin-left: calc(-1rem * calc(1 - var(--tw-space-x-reverse)));
}
.-space-x-px > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(-1px * var(--tw-space-x-reverse));
  margin-left: calc(-1px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.divide-x > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-amber-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(255 179 0 / var(--tw-divide-opacity));
}
.divide-blue-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(28 100 242 / var(--tw-divide-opacity));
}
.divide-blue-gray-50 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(236 239 241 / var(--tw-divide-opacity));
}
.divide-blue-gray-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(84 110 122 / var(--tw-divide-opacity));
}
.divide-brown-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(109 76 65 / var(--tw-divide-opacity));
}
.divide-cyan-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(0 172 193 / var(--tw-divide-opacity));
}
.divide-deep-orange-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(244 81 30 / var(--tw-divide-opacity));
}
.divide-deep-purple-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(94 53 177 / var(--tw-divide-opacity));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity));
}
.divide-gray-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-divide-opacity));
}
.divide-green-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(5 122 85 / var(--tw-divide-opacity));
}
.divide-indigo-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(88 80 236 / var(--tw-divide-opacity));
}
.divide-light-blue-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(3 155 229 / var(--tw-divide-opacity));
}
.divide-light-green-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(124 179 66 / var(--tw-divide-opacity));
}
.divide-lime-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(192 202 51 / var(--tw-divide-opacity));
}
.divide-orange-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(208 56 1 / var(--tw-divide-opacity));
}
.divide-pink-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(214 31 105 / var(--tw-divide-opacity));
}
.divide-purple-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(126 58 242 / var(--tw-divide-opacity));
}
.divide-red-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(224 36 36 / var(--tw-divide-opacity));
}
.divide-teal-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(4 116 129 / var(--tw-divide-opacity));
}
.divide-yellow-600 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(159 88 10 / var(--tw-divide-opacity));
}
.self-start {
  align-self: flex-start;
}
.self-center {
  align-self: center;
}
.justify-self-end {
  justify-self: end;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.\\!overflow-x-hidden {
  overflow-x: hidden !important;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.\\!scroll-auto {
  scroll-behavior: auto !important;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.\\!rounded-full {
  border-radius: 9999px !important;
}
.\\!rounded-none {
  border-radius: 0px !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[30px\\] {
  border-radius: 30px;
}
.rounded-\\[7px\\] {
  border-radius: 7px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.rounded-e-lg {
  border-start-end-radius: 0.5rem;
  border-end-end-radius: 0.5rem;
}
.rounded-l-full {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.rounded-l-md {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.rounded-r-none {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.rounded-s-lg {
  border-start-start-radius: 0.5rem;
  border-end-start-radius: 0.5rem;
}
.rounded-t {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[2px\\] {
  border-width: 2px;
}
.border-\\[4px\\] {
  border-width: 4px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l {
  border-left-width: 1px;
}
.border-l-0 {
  border-left-width: 0px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-r-0 {
  border-right-width: 0px;
}
.border-r-2 {
  border-right-width: 2px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-t-4 {
  border-top-width: 4px;
}
.border-solid {
  border-style: solid;
}
.border-\\[\\#2e2e2e\\] {
  --tw-border-opacity: 1;
  border-color: rgb(46 46 46 / var(--tw-border-opacity));
}
.border-\\[\\#343434\\] {
  --tw-border-opacity: 1;
  border-color: rgb(52 52 52 / var(--tw-border-opacity));
}
.border-\\[\\#373737\\] {
  --tw-border-opacity: 1;
  border-color: rgb(55 55 55 / var(--tw-border-opacity));
}
.border-\\[\\#676767\\] {
  --tw-border-opacity: 1;
  border-color: rgb(103 103 103 / var(--tw-border-opacity));
}
.border-\\[\\#F7D091\\] {
  --tw-border-opacity: 1;
  border-color: rgb(247 208 145 / var(--tw-border-opacity));
}
.border-\\[\\#ceae7b\\] {
  --tw-border-opacity: 1;
  border-color: rgb(206 174 123 / var(--tw-border-opacity));
}
.border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(63 131 248 / var(--tw-border-opacity));
}
.border-blue-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(207 216 220 / var(--tw-border-opacity));
}
.border-blue-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}
.border-blue-gray-50 {
  --tw-border-opacity: 1;
  border-color: rgb(236 239 241 / var(--tw-border-opacity));
}
.border-blue-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}
.border-brown-500 {
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}
.border-cyan-300 {
  --tw-border-opacity: 1;
  border-color: rgb(77 208 225 / var(--tw-border-opacity));
}
.border-cyan-500 {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}
.border-cyan-600 {
  --tw-border-opacity: 1;
  border-color: rgb(0 172 193 / var(--tw-border-opacity));
}
.border-cyan-700 {
  --tw-border-opacity: 1;
  border-color: rgb(0 151 167 / var(--tw-border-opacity));
}
.border-deep-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}
.border-deep-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}
.border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity));
}
.border-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity));
}
.border-gray-900 {
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity));
}
.border-green-300 {
  --tw-border-opacity: 1;
  border-color: rgb(132 225 188 / var(--tw-border-opacity));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity));
}
.border-green-600 {
  --tw-border-opacity: 1;
  border-color: rgb(5 122 85 / var(--tw-border-opacity));
}
.border-green-700 {
  --tw-border-opacity: 1;
  border-color: rgb(4 108 78 / var(--tw-border-opacity));
}
.border-indigo-300 {
  --tw-border-opacity: 1;
  border-color: rgb(180 198 252 / var(--tw-border-opacity));
}
.border-indigo-400 {
  --tw-border-opacity: 1;
  border-color: rgb(141 162 251 / var(--tw-border-opacity));
}
.border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(104 117 245 / var(--tw-border-opacity));
}
.border-light-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}
.border-light-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}
.border-lime-300 {
  --tw-border-opacity: 1;
  border-color: rgb(220 231 117 / var(--tw-border-opacity));
}
.border-lime-400 {
  --tw-border-opacity: 1;
  border-color: rgb(212 225 87 / var(--tw-border-opacity));
}
.border-lime-500 {
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}
.border-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 90 31 / var(--tw-border-opacity));
}
.border-pink-300 {
  --tw-border-opacity: 1;
  border-color: rgb(248 180 217 / var(--tw-border-opacity));
}
.border-pink-500 {
  --tw-border-opacity: 1;
  border-color: rgb(231 70 148 / var(--tw-border-opacity));
}
.border-pink-600 {
  --tw-border-opacity: 1;
  border-color: rgb(214 31 105 / var(--tw-border-opacity));
}
.border-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(144 97 249 / var(--tw-border-opacity));
}
.border-purple-900 {
  --tw-border-opacity: 1;
  border-color: rgb(74 29 150 / var(--tw-border-opacity));
}
.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(248 180 180 / var(--tw-border-opacity));
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity));
}
.border-red-600 {
  --tw-border-opacity: 1;
  border-color: rgb(224 36 36 / var(--tw-border-opacity));
}
.border-red-900 {
  --tw-border-opacity: 1;
  border-color: rgb(119 29 29 / var(--tw-border-opacity));
}
.border-teal-300 {
  --tw-border-opacity: 1;
  border-color: rgb(126 220 226 / var(--tw-border-opacity));
}
.border-teal-500 {
  --tw-border-opacity: 1;
  border-color: rgb(6 148 162 / var(--tw-border-opacity));
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}
.border-white\\/80 {
  border-color: rgb(255 255 255 / 0.8);
}
.border-yellow-300 {
  --tw-border-opacity: 1;
  border-color: rgb(250 202 21 / var(--tw-border-opacity));
}
.border-yellow-400 {
  --tw-border-opacity: 1;
  border-color: rgb(227 160 8 / var(--tw-border-opacity));
}
.border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(194 120 3 / var(--tw-border-opacity));
}
.border-yellow-600 {
  --tw-border-opacity: 1;
  border-color: rgb(159 88 10 / var(--tw-border-opacity));
}
.\\!border-t-transparent {
  border-top-color: transparent !important;
}
.border-b-blue-gray-100 {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(207 216 220 / var(--tw-border-opacity));
}
.border-l-transparent {
  border-left-color: transparent;
}
.border-r-transparent {
  border-right-color: transparent;
}
.border-t-blue-gray-100 {
  --tw-border-opacity: 1;
  border-top-color: rgb(207 216 220 / var(--tw-border-opacity));
}
.border-t-transparent {
  border-top-color: transparent;
}
.\\!bg-gray-50 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity)) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.bg-\\[\\#000000\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#000\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-\\[\\#121212\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(18 18 18 / var(--tw-bg-opacity));
}
.bg-\\[\\#161616\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(22 22 22 / var(--tw-bg-opacity));
}
.bg-\\[\\#1e1e1ec9\\] {
  background-color: #1e1e1ec9;
}
.bg-\\[\\#2F2F2F\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(47 47 47 / var(--tw-bg-opacity));
}
.bg-\\[\\#2f2f2f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(47 47 47 / var(--tw-bg-opacity));
}
.bg-\\[\\#31313169\\] {
  background-color: #31313169;
}
.bg-\\[\\#373737\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(55 55 55 / var(--tw-bg-opacity));
}
.bg-\\[\\#3D3D3D\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(61 61 61 / var(--tw-bg-opacity));
}
.bg-\\[\\#F7D091\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(247 208 145 / var(--tw-bg-opacity));
}
.bg-\\[\\#ceae7b\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(206 174 123 / var(--tw-bg-opacity));
}
.bg-\\[\\#f5f5f5\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.bg-\\[\\#ffffff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}
.bg-amber-500\\/10 {
  background-color: rgb(255 193 7 / 0.1);
}
.bg-amber-500\\/20 {
  background-color: rgb(255 193 7 / 0.2);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(225 239 254 / var(--tw-bg-opacity));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(63 131 248 / var(--tw-bg-opacity));
}
.bg-blue-500\\/10 {
  background-color: rgb(63 131 248 / 0.1);
}
.bg-blue-500\\/20 {
  background-color: rgb(63 131 248 / 0.2);
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(28 100 242 / var(--tw-bg-opacity));
}
.bg-blue-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(26 86 219 / var(--tw-bg-opacity));
}
.bg-blue-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(207 216 220 / var(--tw-bg-opacity));
}
.bg-blue-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(176 190 197 / var(--tw-bg-opacity));
}
.bg-blue-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}
.bg-blue-gray-50\\/50 {
  background-color: rgb(236 239 241 / 0.5);
}
.bg-blue-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}
.bg-blue-gray-500\\/10 {
  background-color: rgb(96 125 139 / 0.1);
}
.bg-blue-gray-500\\/20 {
  background-color: rgb(96 125 139 / 0.2);
}
.bg-brown-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}
.bg-brown-500\\/10 {
  background-color: rgb(121 85 72 / 0.1);
}
.bg-brown-500\\/20 {
  background-color: rgb(121 85 72 / 0.2);
}
.bg-current {
  background-color: currentColor;
}
.bg-cyan-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(178 235 242 / var(--tw-bg-opacity));
}
.bg-cyan-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(128 222 234 / var(--tw-bg-opacity));
}
.bg-cyan-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 247 250 / var(--tw-bg-opacity));
}
.bg-cyan-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}
.bg-cyan-500\\/10 {
  background-color: rgb(0 188 212 / 0.1);
}
.bg-cyan-500\\/20 {
  background-color: rgb(0 188 212 / 0.2);
}
.bg-cyan-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 172 193 / var(--tw-bg-opacity));
}
.bg-cyan-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(0 151 167 / var(--tw-bg-opacity));
}
.bg-deep-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}
.bg-deep-orange-500\\/10 {
  background-color: rgb(255 87 34 / 0.1);
}
.bg-deep-orange-500\\/20 {
  background-color: rgb(255 87 34 / 0.2);
}
.bg-deep-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}
.bg-deep-purple-500\\/10 {
  background-color: rgb(103 58 183 / 0.1);
}
.bg-deep-purple-500\\/20 {
  background-color: rgb(103 58 183 / 0.2);
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
.bg-gray-500\\/10 {
  background-color: rgb(107 114 128 / 0.1);
}
.bg-gray-500\\/20 {
  background-color: rgb(107 114 128 / 0.2);
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
.bg-gray-900\\/50 {
  background-color: rgb(17 24 39 / 0.5);
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(222 247 236 / var(--tw-bg-opacity));
}
.bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(49 196 141 / var(--tw-bg-opacity));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 250 247 / var(--tw-bg-opacity));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(14 159 110 / var(--tw-bg-opacity));
}
.bg-green-500\\/10 {
  background-color: rgb(14 159 110 / 0.1);
}
.bg-green-500\\/20 {
  background-color: rgb(14 159 110 / 0.2);
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 122 85 / var(--tw-bg-opacity));
}
.bg-green-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(4 108 78 / var(--tw-bg-opacity));
}
.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 237 255 / var(--tw-bg-opacity));
}
.bg-indigo-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(141 162 251 / var(--tw-bg-opacity));
}
.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(104 117 245 / var(--tw-bg-opacity));
}
.bg-indigo-500\\/10 {
  background-color: rgb(104 117 245 / 0.1);
}
.bg-indigo-500\\/20 {
  background-color: rgb(104 117 245 / 0.2);
}
.bg-indigo-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(88 80 236 / var(--tw-bg-opacity));
}
.bg-light-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}
.bg-light-blue-500\\/10 {
  background-color: rgb(3 169 244 / 0.1);
}
.bg-light-blue-500\\/20 {
  background-color: rgb(3 169 244 / 0.2);
}
.bg-light-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}
.bg-light-green-500\\/10 {
  background-color: rgb(139 195 74 / 0.1);
}
.bg-light-green-500\\/20 {
  background-color: rgb(139 195 74 / 0.2);
}
.bg-lime-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 244 195 / var(--tw-bg-opacity));
}
.bg-lime-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(212 225 87 / var(--tw-bg-opacity));
}
.bg-lime-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}
.bg-lime-500\\/10 {
  background-color: rgb(205 220 57 / 0.1);
}
.bg-lime-500\\/20 {
  background-color: rgb(205 220 57 / 0.2);
}
.bg-lime-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(192 202 51 / var(--tw-bg-opacity));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 90 31 / var(--tw-bg-opacity));
}
.bg-orange-500\\/10 {
  background-color: rgb(255 90 31 / 0.1);
}
.bg-orange-500\\/20 {
  background-color: rgb(255 90 31 / 0.2);
}
.bg-pink-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 232 243 / var(--tw-bg-opacity));
}
.bg-pink-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(231 70 148 / var(--tw-bg-opacity));
}
.bg-pink-500\\/10 {
  background-color: rgb(231 70 148 / 0.1);
}
.bg-pink-500\\/20 {
  background-color: rgb(231 70 148 / 0.2);
}
.bg-pink-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(214 31 105 / var(--tw-bg-opacity));
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(237 235 254 / var(--tw-bg-opacity));
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(246 245 255 / var(--tw-bg-opacity));
}
.bg-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(144 97 249 / var(--tw-bg-opacity));
}
.bg-purple-500\\/10 {
  background-color: rgb(144 97 249 / 0.1);
}
.bg-purple-500\\/20 {
  background-color: rgb(144 97 249 / 0.2);
}
.bg-purple-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(126 58 242 / var(--tw-bg-opacity));
}
.bg-purple-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(108 43 217 / var(--tw-bg-opacity));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 232 232 / var(--tw-bg-opacity));
}
.bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 128 128 / var(--tw-bg-opacity));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 242 / var(--tw-bg-opacity));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 82 82 / var(--tw-bg-opacity));
}
.bg-red-500\\/10 {
  background-color: rgb(240 82 82 / 0.1);
}
.bg-red-500\\/20 {
  background-color: rgb(240 82 82 / 0.2);
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 36 36 / var(--tw-bg-opacity));
}
.bg-red-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(200 30 30 / var(--tw-bg-opacity));
}
.bg-teal-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(213 245 246 / var(--tw-bg-opacity));
}
.bg-teal-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 148 162 / var(--tw-bg-opacity));
}
.bg-teal-500\\/10 {
  background-color: rgb(6 148 162 / 0.1);
}
.bg-teal-500\\/20 {
  background-color: rgb(6 148 162 / 0.2);
}
.bg-teal-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(4 116 129 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/30 {
  background-color: rgb(255 255 255 / 0.3);
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 246 178 / var(--tw-bg-opacity));
}
.bg-yellow-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(227 160 8 / var(--tw-bg-opacity));
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 253 234 / var(--tw-bg-opacity));
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(194 120 3 / var(--tw-bg-opacity));
}
.bg-yellow-500\\/10 {
  background-color: rgb(194 120 3 / 0.1);
}
.bg-yellow-500\\/20 {
  background-color: rgb(194 120 3 / 0.2);
}
.bg-yellow-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(159 88 10 / var(--tw-bg-opacity));
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-60 {
  --tw-bg-opacity: 0.6;
}
.bg-opacity-80 {
  --tw-bg-opacity: 0.8;
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-tr {
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-\\[\\#F7D091\\] {
  --tw-gradient-from: #F7D091 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(247 208 145 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-600 {
  --tw-gradient-from: #ffb300 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 179 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600 {
  --tw-gradient-from: #1C64F2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(28 100 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-gray-600 {
  --tw-gradient-from: #546e7a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(84 110 122 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-brown-600 {
  --tw-gradient-from: #6d4c41 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(109 76 65 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-400 {
  --tw-gradient-from: #26c6da var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(38 198 218 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-500 {
  --tw-gradient-from: #00bcd4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 188 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-600 {
  --tw-gradient-from: #00acc1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 172 193 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-deep-orange-600 {
  --tw-gradient-from: #f4511e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 81 30 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-deep-purple-600 {
  --tw-gradient-from: #5e35b1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(94 53 177 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-600 {
  --tw-gradient-from: #4B5563 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(75 85 99 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-400 {
  --tw-gradient-from: #31C48D var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(49 196 141 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-600 {
  --tw-gradient-from: #057A55 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(5 122 85 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-600 {
  --tw-gradient-from: #5850EC var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(88 80 236 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-light-blue-600 {
  --tw-gradient-from: #039be5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(3 155 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-light-green-600 {
  --tw-gradient-from: #7cb342 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 179 66 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-lime-200 {
  --tw-gradient-from: #e6ee9c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(230 238 156 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-lime-600 {
  --tw-gradient-from: #c0ca33 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(192 202 51 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-600 {
  --tw-gradient-from: #D03801 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(208 56 1 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-400 {
  --tw-gradient-from: #F17EB8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(241 126 184 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-500 {
  --tw-gradient-from: #E74694 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(231 70 148 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-600 {
  --tw-gradient-from: #D61F69 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(214 31 105 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500 {
  --tw-gradient-from: #9061F9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(144 97 249 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600 {
  --tw-gradient-from: #7E3AF2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(126 58 242 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-200 {
  --tw-gradient-from: #FBD5D5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 213 213 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-400 {
  --tw-gradient-from: #F98080 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 128 128 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-600 {
  --tw-gradient-from: #E02424 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(224 36 36 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-200 {
  --tw-gradient-from: #AFECEF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(175 236 239 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-400 {
  --tw-gradient-from: #16BDCA var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 189 202 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-600 {
  --tw-gradient-from: #047481 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(4 116 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-600 {
  --tw-gradient-from: #9F580A var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(159 88 10 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-cyan-500 {
  --tw-gradient-to: rgb(0 188 212 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #00bcd4 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-600 {
  --tw-gradient-to: rgb(0 172 193 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #00acc1 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-green-500 {
  --tw-gradient-to: rgb(14 159 110 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0E9F6E var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-lime-400 {
  --tw-gradient-to: rgb(212 225 87 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #d4e157 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-pink-500 {
  --tw-gradient-to: rgb(231 70 148 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #E74694 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-600 {
  --tw-gradient-to: rgb(126 58 242 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #7E3AF2 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-red-300 {
  --tw-gradient-to: rgb(248 180 180 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #F8B4B4 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-red-500 {
  --tw-gradient-to: rgb(240 82 82 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #F05252 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-teal-500 {
  --tw-gradient-to: rgb(6 148 162 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #0694A2 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#917A55\\] {
  --tw-gradient-to: #917A55 var(--tw-gradient-to-position);
}
.to-amber-400 {
  --tw-gradient-to: #ffca28 var(--tw-gradient-to-position);
}
.to-blue-400 {
  --tw-gradient-to: #76A9FA var(--tw-gradient-to-position);
}
.to-blue-gray-400 {
  --tw-gradient-to: #78909c var(--tw-gradient-to-position);
}
.to-brown-400 {
  --tw-gradient-to: #8d6e63 var(--tw-gradient-to-position);
}
.to-cyan-400 {
  --tw-gradient-to: #26c6da var(--tw-gradient-to-position);
}
.to-cyan-500 {
  --tw-gradient-to: #00bcd4 var(--tw-gradient-to-position);
}
.to-cyan-600 {
  --tw-gradient-to: #00acc1 var(--tw-gradient-to-position);
}
.to-cyan-700 {
  --tw-gradient-to: #0097a7 var(--tw-gradient-to-position);
}
.to-deep-orange-400 {
  --tw-gradient-to: #ff7043 var(--tw-gradient-to-position);
}
.to-deep-purple-400 {
  --tw-gradient-to: #7e57c2 var(--tw-gradient-to-position);
}
.to-gray-400 {
  --tw-gradient-to: #9CA3AF var(--tw-gradient-to-position);
}
.to-green-400 {
  --tw-gradient-to: #31C48D var(--tw-gradient-to-position);
}
.to-green-600 {
  --tw-gradient-to: #057A55 var(--tw-gradient-to-position);
}
.to-indigo-400 {
  --tw-gradient-to: #8DA2FB var(--tw-gradient-to-position);
}
.to-light-blue-400 {
  --tw-gradient-to: #29b6f6 var(--tw-gradient-to-position);
}
.to-light-green-400 {
  --tw-gradient-to: #9ccc65 var(--tw-gradient-to-position);
}
.to-lime-200 {
  --tw-gradient-to: #e6ee9c var(--tw-gradient-to-position);
}
.to-lime-400 {
  --tw-gradient-to: #d4e157 var(--tw-gradient-to-position);
}
.to-lime-500 {
  --tw-gradient-to: #cddc39 var(--tw-gradient-to-position);
}
.to-orange-400 {
  --tw-gradient-to: #FF8A4C var(--tw-gradient-to-position);
}
.to-pink-400 {
  --tw-gradient-to: #F17EB8 var(--tw-gradient-to-position);
}
.to-pink-500 {
  --tw-gradient-to: #E74694 var(--tw-gradient-to-position);
}
.to-pink-600 {
  --tw-gradient-to: #D61F69 var(--tw-gradient-to-position);
}
.to-purple-400 {
  --tw-gradient-to: #AC94FA var(--tw-gradient-to-position);
}
.to-purple-700 {
  --tw-gradient-to: #6C2BD9 var(--tw-gradient-to-position);
}
.to-red-400 {
  --tw-gradient-to: #F98080 var(--tw-gradient-to-position);
}
.to-red-600 {
  --tw-gradient-to: #E02424 var(--tw-gradient-to-position);
}
.to-teal-400 {
  --tw-gradient-to: #16BDCA var(--tw-gradient-to-position);
}
.to-teal-600 {
  --tw-gradient-to: #047481 var(--tw-gradient-to-position);
}
.to-yellow-200 {
  --tw-gradient-to: #FCE96A var(--tw-gradient-to-position);
}
.to-yellow-400 {
  --tw-gradient-to: #E3A008 var(--tw-gradient-to-position);
}
.bg-fixed {
  background-attachment: fixed;
}
.bg-clip-border {
  background-clip: border-box;
}
.bg-clip-text {
  -webkit-background-clip: text;
          background-clip: text;
}
.fill-current {
  fill: currentColor;
}
.fill-cyan-600 {
  fill: #00acc1;
}
.fill-gray-600 {
  fill: #4B5563;
}
.fill-green-500 {
  fill: #0E9F6E;
}
.fill-pink-600 {
  fill: #D61F69;
}
.fill-purple-600 {
  fill: #7E3AF2;
}
.fill-red-600 {
  fill: #E02424;
}
.fill-yellow-400 {
  fill: #E3A008;
}
.object-cover {
  object-fit: cover;
}
.object-center {
  object-position: center;
}
.object-top {
  object-position: top;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-7 {
  padding: 1.75rem;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[5px\\] {
  padding-left: 5px;
  padding-right: 5px;
}
.px-px {
  padding-left: 1px;
  padding-right: 1px;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.\\!pr-7 {
  padding-right: 1.75rem !important;
}
.\\!pr-9 {
  padding-right: 2.25rem !important;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-2\\.5 {
  padding-bottom: 0.625rem;
}
.pb-7 {
  padding-bottom: 1.75rem;
}
.pl-0 {
  padding-left: 0px;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-12 {
  padding-left: 3rem;
}
.pl-16 {
  padding-left: 4rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-2\\.5 {
  padding-left: 0.625rem;
}
.pl-20 {
  padding-left: 5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-8 {
  padding-left: 2rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pr-8 {
  padding-right: 2rem;
}
.ps-5 {
  padding-inline-start: 1.25rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-0\\.5 {
  padding-top: 0.125rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-\\[10rem\\] {
  padding-top: 10rem;
}
.pt-\\[5px\\] {
  padding-top: 5px;
}
.pt-\\[9px\\] {
  padding-top: 9px;
}
.pt-px {
  padding-top: 1px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.align-middle {
  vertical-align: middle;
}
.font-General-Sans {
  font-family: General Sans, sans-serif;
}
.font-sans {
  font-family: Roboto, sans-serif;
}
.\\!text-\\[11px\\] {
  font-size: 11px !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-\\[1\\.3rem\\] {
  font-size: 1.3rem;
}
.text-\\[1\\.4rem\\] {
  font-size: 1.4rem;
}
.text-\\[1\\.5rem\\] {
  font-size: 1.5rem;
}
.text-\\[1\\.7rem\\] {
  font-size: 1.7rem;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[1rem\\] {
  font-size: 1rem;
}
.text-\\[2\\.3rem\\] {
  font-size: 2.3rem;
}
.text-\\[3rem\\] {
  font-size: 3rem;
}
.text-\\[5rem\\] {
  font-size: 5rem;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-sm\\/6 {
  font-size: 0.875rem;
  line-height: 1.5rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-\\[400\\] {
  font-weight: 400;
}
.font-\\[500\\] {
  font-weight: 500;
}
.font-\\[600\\] {
  font-weight: 600;
}
.font-\\[700\\] {
  font-weight: 700;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.\\!leading-tight {
  line-height: 1.25 !important;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-9 {
  line-height: 2.25rem;
}
.leading-\\[1\\.3\\] {
  line-height: 1.3;
}
.leading-\\[3\\.75\\] {
  line-height: 3.75;
}
.leading-\\[4\\.1\\] {
  line-height: 4.1;
}
.leading-\\[4\\.25\\] {
  line-height: 4.25;
}
.leading-\\[4\\.875\\] {
  line-height: 4.875;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity)) !important;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}
.text-\\[\\#121212\\] {
  --tw-text-opacity: 1;
  color: rgb(18 18 18 / var(--tw-text-opacity));
}
.text-\\[\\#161616\\] {
  --tw-text-opacity: 1;
  color: rgb(22 22 22 / var(--tw-text-opacity));
}
.text-\\[\\#676767\\] {
  --tw-text-opacity: 1;
  color: rgb(103 103 103 / var(--tw-text-opacity));
}
.text-\\[\\#D9D9D9\\] {
  --tw-text-opacity: 1;
  color: rgb(217 217 217 / var(--tw-text-opacity));
}
.text-\\[\\#F7D091\\] {
  --tw-text-opacity: 1;
  color: rgb(247 208 145 / var(--tw-text-opacity));
}
.text-\\[\\#ceae7b\\] {
  --tw-text-opacity: 1;
  color: rgb(206 174 123 / var(--tw-text-opacity));
}
.text-\\[\\#f5f5f5\\] {
  --tw-text-opacity: 1;
  color: rgb(245 245 245 / var(--tw-text-opacity));
}
.text-\\[\\#ffffff\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-\\[white\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(255 193 7 / var(--tw-text-opacity));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(255 160 0 / var(--tw-text-opacity));
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(255 111 0 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(63 131 248 / var(--tw-text-opacity));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(26 86 219 / var(--tw-text-opacity));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 66 159 / var(--tw-text-opacity));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(35 56 118 / var(--tw-text-opacity));
}
.text-blue-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(207 216 220 / var(--tw-text-opacity));
}
.text-blue-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(120 144 156 / var(--tw-text-opacity));
}
.text-blue-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}
.text-blue-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(69 90 100 / var(--tw-text-opacity));
}
.text-blue-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}
.text-brown-500 {
  --tw-text-opacity: 1;
  color: rgb(121 85 72 / var(--tw-text-opacity));
}
.text-brown-700 {
  --tw-text-opacity: 1;
  color: rgb(93 64 55 / var(--tw-text-opacity));
}
.text-brown-900 {
  --tw-text-opacity: 1;
  color: rgb(62 39 35 / var(--tw-text-opacity));
}
.text-current {
  color: currentColor;
}
.text-cyan-300 {
  --tw-text-opacity: 1;
  color: rgb(77 208 225 / var(--tw-text-opacity));
}
.text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(0 188 212 / var(--tw-text-opacity));
}
.text-cyan-600 {
  --tw-text-opacity: 1;
  color: rgb(0 172 193 / var(--tw-text-opacity));
}
.text-cyan-700 {
  --tw-text-opacity: 1;
  color: rgb(0 151 167 / var(--tw-text-opacity));
}
.text-cyan-800 {
  --tw-text-opacity: 1;
  color: rgb(0 131 143 / var(--tw-text-opacity));
}
.text-cyan-900 {
  --tw-text-opacity: 1;
  color: rgb(0 96 100 / var(--tw-text-opacity));
}
.text-deep-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 87 34 / var(--tw-text-opacity));
}
.text-deep-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(230 74 25 / var(--tw-text-opacity));
}
.text-deep-orange-900 {
  --tw-text-opacity: 1;
  color: rgb(191 54 12 / var(--tw-text-opacity));
}
.text-deep-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(103 58 183 / var(--tw-text-opacity));
}
.text-deep-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(81 45 168 / var(--tw-text-opacity));
}
.text-deep-purple-900 {
  --tw-text-opacity: 1;
  color: rgb(49 27 146 / var(--tw-text-opacity));
}
.text-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(14 159 110 / var(--tw-text-opacity));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(5 122 85 / var(--tw-text-opacity));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(4 108 78 / var(--tw-text-opacity));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(3 84 63 / var(--tw-text-opacity));
}
.text-green-900 {
  --tw-text-opacity: 1;
  color: rgb(1 71 55 / var(--tw-text-opacity));
}
.text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(104 117 245 / var(--tw-text-opacity));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(88 80 236 / var(--tw-text-opacity));
}
.text-indigo-700 {
  --tw-text-opacity: 1;
  color: rgb(81 69 205 / var(--tw-text-opacity));
}
.text-indigo-800 {
  --tw-text-opacity: 1;
  color: rgb(66 56 157 / var(--tw-text-opacity));
}
.text-indigo-900 {
  --tw-text-opacity: 1;
  color: rgb(54 47 120 / var(--tw-text-opacity));
}
.text-inherit {
  color: inherit;
}
.text-light-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(3 169 244 / var(--tw-text-opacity));
}
.text-light-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(2 136 209 / var(--tw-text-opacity));
}
.text-light-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(1 87 155 / var(--tw-text-opacity));
}
.text-light-green-500 {
  --tw-text-opacity: 1;
  color: rgb(139 195 74 / var(--tw-text-opacity));
}
.text-light-green-700 {
  --tw-text-opacity: 1;
  color: rgb(104 159 56 / var(--tw-text-opacity));
}
.text-light-green-900 {
  --tw-text-opacity: 1;
  color: rgb(51 105 30 / var(--tw-text-opacity));
}
.text-lime-500 {
  --tw-text-opacity: 1;
  color: rgb(205 220 57 / var(--tw-text-opacity));
}
.text-lime-700 {
  --tw-text-opacity: 1;
  color: rgb(175 180 43 / var(--tw-text-opacity));
}
.text-lime-800 {
  --tw-text-opacity: 1;
  color: rgb(158 157 36 / var(--tw-text-opacity));
}
.text-lime-900 {
  --tw-text-opacity: 1;
  color: rgb(130 119 23 / var(--tw-text-opacity));
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 90 31 / var(--tw-text-opacity));
}
.text-orange-700 {
  --tw-text-opacity: 1;
  color: rgb(180 52 3 / var(--tw-text-opacity));
}
.text-orange-900 {
  --tw-text-opacity: 1;
  color: rgb(119 29 29 / var(--tw-text-opacity));
}
.text-pink-500 {
  --tw-text-opacity: 1;
  color: rgb(231 70 148 / var(--tw-text-opacity));
}
.text-pink-600 {
  --tw-text-opacity: 1;
  color: rgb(214 31 105 / var(--tw-text-opacity));
}
.text-pink-700 {
  --tw-text-opacity: 1;
  color: rgb(191 18 93 / var(--tw-text-opacity));
}
.text-pink-800 {
  --tw-text-opacity: 1;
  color: rgb(153 21 75 / var(--tw-text-opacity));
}
.text-pink-900 {
  --tw-text-opacity: 1;
  color: rgb(117 26 61 / var(--tw-text-opacity));
}
.text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(144 97 249 / var(--tw-text-opacity));
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(126 58 242 / var(--tw-text-opacity));
}
.text-purple-700 {
  --tw-text-opacity: 1;
  color: rgb(108 43 217 / var(--tw-text-opacity));
}
.text-purple-800 {
  --tw-text-opacity: 1;
  color: rgb(85 33 181 / var(--tw-text-opacity));
}
.text-purple-900 {
  --tw-text-opacity: 1;
  color: rgb(74 29 150 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(240 82 82 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(224 36 36 / var(--tw-text-opacity));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(200 30 30 / var(--tw-text-opacity));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(155 28 28 / var(--tw-text-opacity));
}
.text-red-900 {
  --tw-text-opacity: 1;
  color: rgb(119 29 29 / var(--tw-text-opacity));
}
.text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(6 148 162 / var(--tw-text-opacity));
}
.text-teal-600 {
  --tw-text-opacity: 1;
  color: rgb(4 116 129 / var(--tw-text-opacity));
}
.text-teal-700 {
  --tw-text-opacity: 1;
  color: rgb(3 102 114 / var(--tw-text-opacity));
}
.text-teal-800 {
  --tw-text-opacity: 1;
  color: rgb(5 80 92 / var(--tw-text-opacity));
}
.text-teal-900 {
  --tw-text-opacity: 1;
  color: rgb(1 68 81 / var(--tw-text-opacity));
}
.text-transparent {
  color: transparent;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(227 160 8 / var(--tw-text-opacity));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(194 120 3 / var(--tw-text-opacity));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(142 75 16 / var(--tw-text-opacity));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(114 59 19 / var(--tw-text-opacity));
}
.text-yellow-900 {
  --tw-text-opacity: 1;
  color: rgb(99 49 18 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.underline-offset-4 {
  text-underline-offset: 4px;
}
.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.placeholder-cyan-700::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(0 151 167 / var(--tw-placeholder-opacity));
}
.placeholder-green-700::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(4 108 78 / var(--tw-placeholder-opacity));
}
.placeholder-red-700::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(200 30 30 / var(--tw-placeholder-opacity));
}
.placeholder-yellow-700::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(142 75 16 / var(--tw-placeholder-opacity));
}
.opacity-0 {
  opacity: 0;
}
.opacity-10 {
  opacity: 0.1;
}
.opacity-100 {
  opacity: 1;
}
.opacity-50 {
  opacity: 0.5;
}
.mix-blend-overlay {
  mix-blend-mode: overlay;
}
.mix-blend-lighten {
  mix-blend-mode: lighten;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-amber-500\\/20 {
  --tw-shadow-color: rgb(255 193 7 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-amber-500\\/40 {
  --tw-shadow-color: rgb(255 193 7 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-500\\/20 {
  --tw-shadow-color: rgb(63 131 248 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-500\\/40 {
  --tw-shadow-color: rgb(63 131 248 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-500\\/10 {
  --tw-shadow-color: rgb(96 125 139 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-500\\/20 {
  --tw-shadow-color: rgb(96 125 139 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-500\\/40 {
  --tw-shadow-color: rgb(96 125 139 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-gray-900\\/10 {
  --tw-shadow-color: rgb(38 50 56 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-brown-500\\/20 {
  --tw-shadow-color: rgb(121 85 72 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-brown-500\\/40 {
  --tw-shadow-color: rgb(121 85 72 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-cyan-500\\/20 {
  --tw-shadow-color: rgb(0 188 212 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-cyan-500\\/40 {
  --tw-shadow-color: rgb(0 188 212 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-orange-500\\/20 {
  --tw-shadow-color: rgb(255 87 34 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-orange-500\\/40 {
  --tw-shadow-color: rgb(255 87 34 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-purple-500\\/20 {
  --tw-shadow-color: rgb(103 58 183 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-deep-purple-500\\/40 {
  --tw-shadow-color: rgb(103 58 183 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-500\\/20 {
  --tw-shadow-color: rgb(107 114 128 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-gray-500\\/40 {
  --tw-shadow-color: rgb(107 114 128 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-500\\/20 {
  --tw-shadow-color: rgb(14 159 110 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-500\\/40 {
  --tw-shadow-color: rgb(14 159 110 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-500\\/20 {
  --tw-shadow-color: rgb(104 117 245 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-500\\/40 {
  --tw-shadow-color: rgb(104 117 245 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-blue-500\\/20 {
  --tw-shadow-color: rgb(3 169 244 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-blue-500\\/40 {
  --tw-shadow-color: rgb(3 169 244 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-green-500\\/20 {
  --tw-shadow-color: rgb(139 195 74 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-light-green-500\\/40 {
  --tw-shadow-color: rgb(139 195 74 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-lime-500\\/20 {
  --tw-shadow-color: rgb(205 220 57 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-lime-500\\/40 {
  --tw-shadow-color: rgb(205 220 57 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-500\\/20 {
  --tw-shadow-color: rgb(255 90 31 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-500\\/40 {
  --tw-shadow-color: rgb(255 90 31 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-pink-500\\/20 {
  --tw-shadow-color: rgb(231 70 148 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-pink-500\\/40 {
  --tw-shadow-color: rgb(231 70 148 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-500\\/20 {
  --tw-shadow-color: rgb(144 97 249 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-500\\/40 {
  --tw-shadow-color: rgb(144 97 249 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-500\\/20 {
  --tw-shadow-color: rgb(240 82 82 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-500\\/40 {
  --tw-shadow-color: rgb(240 82 82 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-500\\/20 {
  --tw-shadow-color: rgb(6 148 162 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-teal-500\\/40 {
  --tw-shadow-color: rgb(6 148 162 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-yellow-500\\/20 {
  --tw-shadow-color: rgb(194 120 3 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-yellow-500\\/40 {
  --tw-shadow-color: rgb(194 120 3 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.outline-0 {
  outline-width: 0px;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-0 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-8 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(8px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-black {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity));
}
.ring-blue-100 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(225 239 254 / var(--tw-ring-opacity));
}
.ring-cyan-400 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(38 198 218 / var(--tw-ring-opacity));
}
.ring-cyan-700 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 151 167 / var(--tw-ring-opacity));
}
.ring-gray-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity));
}
.ring-gray-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity));
}
.ring-gray-800 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(31 41 55 / var(--tw-ring-opacity));
}
.ring-green-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 159 110 / var(--tw-ring-opacity));
}
.ring-pink-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(231 70 148 / var(--tw-ring-opacity));
}
.ring-purple-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(144 97 249 / var(--tw-ring-opacity));
}
.ring-red-500 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(240 82 82 / var(--tw-ring-opacity));
}
.ring-white {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity));
}
.ring-yellow-300 {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 202 21 / var(--tw-ring-opacity));
}
.ring-opacity-5 {
  --tw-ring-opacity: 0.05;
}
.brightness-\\[60\\%\\] {
  --tw-brightness: brightness(60%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md {
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-2xl {
  --tw-backdrop-blur: blur(40px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-saturate-200 {
  --tw-backdrop-saturate: saturate(2);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[color\\2c background-color\\2c border-color\\2c text-decoration-color\\2c fill\\2c stroke\\2c box-shadow\\] {
  transition-property: color,background-color,border-color,text-decoration-color,fill,stroke,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-0 {
  transition-delay: 0s;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.duration-75 {
  transition-duration: 75ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.content-\\[\\'\\'\\] {
  --tw-content: '';
  content: var(--tw-content);
}
.\\[-webkit-appearance\\:none\\] {
  -webkit-appearance: none;
}
.\\[overflow\\:-moz-scrollbars-none\\] {
  overflow: -moz-scrollbars-none;
}
.\\[scrollbar-width\\:none\\] {
  scrollbar-width: none;
}



:root {
  --color--white: white;
  --color--black: black;
  --typegraphy--brand-font-family: general-sans, sans-serif;
  --color--primary-blue: #4297f7;
  --color--primary-green-500: #40b792;
  --layout--max-width: 1600px;
  --layout--container-inner-padding: 200px;
}

/* homepage */
/* .background-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    filter: brightness(60%);
  }

  #Home {
    position: relative;
  }

  @media (min-width: 1024px) {
    .background-image {
      background-image: url(./assets/bgLarge.jpg);
      background-attachment: fixed;
    }
  }

  @media (max-width: 1023px) {
    .background-image {
      background-image: url(./assets/bgSmall.jpg);
    }
  } */


#Home {
  position: relative;
}

/* prevent image to be dragable */
.selector {
  -webkit-user-drag: none;
  user-drag: none;
  -webkit-user-select: none;
  user-select: none;
}


::-webkit-scrollbar {
  width: 5px;
  background-color: #161616;
}

::-webkit-scrollbar-thumb {
  background-color: #ceae7b;
  border-radius: 10px;
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
  filter: brightness(60%);
}

.background-image-1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
}

.background-image-2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
}

.background-image-3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
}

.background-image-4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
}

.background-image-5 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
}

@media (min-width: 1024px) {
  .background-image {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    background-position: center;
    background-attachment: fixed;
  }

  .background-image-2 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-position: center;
    background-attachment: fixed;
  }

}

@media (max-width: 1023px) {
  .background-image {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
    background-position: center;
  }

  .background-image-2 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-position: center;
  }
}

.line-why-codos-section {
  background-color: #d9d9d9;
  width: 1px;
  height: calc(100% - 20px);
  position: absolute;
  left: 50px;
}

.line-pointer-why-codos-section {
  background-color: #d9d9d9;
  width: 6px;
  height: 1px;
  position: absolute;
  inset: 0% auto auto 0%;
}

.content-card {
  border: 1px solid #ffffff47;
  border-radius: 10px;
  padding: 40px 40px;
  justify-content: center;
  transform: translate(-0%, -0%);
  margin-bottom: 15px;

  .number-metric-display-button {
    background: #F7D091;
    background: linear-gradient(to right, #F7D091 0%, #917A55 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: #3330;
    margin-bottom: 0;
    font-weight: 700;
    line-height: 100%;
    z-index: 9999;
    transform-origin: center left;
    transition: color 0.3s ease;
  }

  .headline-content {
    z-index: 9999;
    transform-origin: center left;
    transition: color 0.3s ease;
  }

  &:before,
  &:after {
    content: '';
    background: rgb(247, 208, 145);
    background: linear-gradient(90deg, rgba(247, 208, 145, 1) 0%, rgba(145, 122, 85, 1) 100%);
    height: 50%;
    width: 0;
    position: absolute;
    transition: .3s cubic-bezier(.785, .135, .15, .86);
  }

  &:before {
    top: 0;
    left: 0;
    right: auto;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  &:after {
    bottom: 0;
    right: 0;
    left: auto;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  &:hover {
    &:before {
      width: 100%;
      right: 0;
      left: auto;
    }

    &:after {
      width: 100%;
      left: 0;
      right: auto;
    }

    .number-metric-display-button {
      background: #151515;
      background: linear-gradient(to right, #444444 0%, #151515 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .headline-content {
      color: #121212;
    }

    .content-card {
      border: none;
      z-index: 9999;
    }
  }
}

.content-card-1 {
  border: 1px solid #ceae7b;
  border-radius: 10px;
  padding: 40px 40px;
  justify-content: center;
  transform: translate(-0%, -0%);
  margin-bottom: 15px;
  position: relative;
  overflow: hidden;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;

  .number-metric-display-button {
    color: #161616;
    margin-bottom: 0;
    font-weight: 600;
    transform-origin: center left;
    opacity: 1;
  }

  .headline-content {
    z-index: 9999;
    transform-origin: center left;
    position: absolute;
    opacity: 0;
    color: #161616;
    height: 100%;
    top: 0;
    bottom: 0;
  }

  &:before {
    content: '';
    background: rgb(247, 208, 145);
    background: linear-gradient(90deg, rgb(247, 208, 145) 0%, rgb(145, 122, 85) 100%);
    height: 100%;
    width: 0;
    position: absolute;
    /* transition: .3s cubic-bezier(.785, .135, .15, .86); */
    transition: all 0.4s ease;
    opacity: 0;
  }

  &:before {
    top: 0;
    left: 0;
    right: auto;
    border-radius: 10px;
  }

  &:hover {
    &:before {
      width: 100%;
      right: 0;
      left: auto;
      opacity: 1;
      transition-delay: 0.25s;
    }

    .number-metric-display-button {
      opacity: 0;
    }

    .headline-content {
      color: #161616;
      opacity: 1;
      transition-delay: 0.6s;
    }

    .content-card {
      border: none;
    }
  }
}

.content-card-2 {
  border: 1px solid #ceae7b;
  border-radius: 10px;
  padding: 40px 40px;
  justify-content: center;
  transform: translate(-0%, -0%);
  margin-bottom: 15px;
  position: relative;
  overflow: hidden;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;

  .number-metric-display-button {
    color: #161616;
    margin-bottom: 0;
    font-weight: 600;
    transform-origin: center left;
    opacity: 1;
  }

  .headline-content {
    z-index: 9999;
    transform-origin: center left;
    position: absolute;
    opacity: 0;
    color: #161616;
    text-align: center;
  }

  &:before {
    content: '';
    background: rgb(247, 208, 145);
    background: linear-gradient(90deg, rgb(247, 208, 145) 0%, rgb(145, 122, 85) 100%);
    height: 100%;
    width: 0;
    position: absolute;
    /* transition: .3s cubic-bezier(.785, .135, .15, .86); */
    transition: all 0.4s ease;
    opacity: 0;
  }

  &:before {
    top: 0;
    left: 0;
    right: auto;
    border-radius: 10px;
  }

  &:hover {
    &:before {
      width: 100%;
      right: 0;
      left: auto;
      opacity: 1;
      transition-delay: 0.25s;
    }

    .number-metric-display-button {
      opacity: 0;
    }

    .headline-content {
      color: #161616;
      opacity: 1;
      transition-delay: 0.6s;
    }

    .content-card {
      border: none;
    }
  }
}

.word-animation {
  display: inline-block;
}


.letter {
  display: inline-block;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.letter.in {
  opacity: 1;
  transform: rotateY(0deg);
}

.letter.out {
  opacity: 0;
  transform: rotateY(-90deg);
}

.letter.behind {
  opacity: 0;
  transform: rotateY(-90deg);
}

.benefits-section-bg {
  pointer-events: none;
  justify-content: flex-end;
  align-items: flex-start;
  display: flex;
  position: absolute;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  left: 0;
  width: 100%;
  height: 100%;
}

.benefits-section-bg-1 {
  pointer-events: none;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  position: absolute;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  right: 0;
  width: 100%;
  height: 100%;
}

.benefits-section-bg-2 {
  pointer-events: none;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
}

.transition-animation {
  display: none;
}

@media only screen and (max-width: 767px) and (min-width: 320px) {

  .benefits-section-bg {
    width: 100%;
    height: 100vh;
    top: -0px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    filter: brightness(30%);
    z-index: -1;
  }

  .benefits-section-bg-1 {
    width: 100%;
    height: 100vh;
    top: -10px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    filter: brightness(30%);
    z-index: -1;
  }

  .benefits-section-bg-2.bg_img {
    width: 100%;
    height: 100%;
    top: 0px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
    background-size: cover;
    opacity: 20%;
  }

  .word-animation {
    display: none;
  }

  .transition-animation {
    display: inline-block;
  }

}

@media only screen and (max-width: 768px) and (min-width: 320px) {
  header {
    transition: background-color 0.3s ease;
    transition: padding-bottom 0.3s ease;
    transition: padding-top 0.3s ease;
  }

  header.scrolled {
    background-color: #1e1e1ef2;
    /* New background color */
    padding-top: 10px !important;
    padding-bottom: 10px !important;

  }
}

@media only screen and (max-width: 1024px) and (min-width: 768px) {

  .benefits-section-bg {
    width: 100%;
    height: 100vh;
    top: -10px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
    filter: brightness(30%);
    z-index: -1;
  }

  .benefits-section-bg-1 {
    width: 100%;
    height: 100vh;
    top: 0px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
    filter: brightness(30%);
    z-index: -1;
  }

  .benefits-section-bg-2.bg_img {
    width: 100%;
    height: 100%;
    top: 0px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
    background-size: cover;

  }

}

@media only screen and (max-width: 2560px) and (min-width: 1440px) {

  .benefits-section-bg {
    width: 60%;
    height: 100%;
    top: 0px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
    bottom: 0;
    z-index: 1;
  }

  .benefits-section-bg-1 {
    width: 70%;
    height: 100%;
    top: -20px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
    bottom: 0;
    z-index: 1;
  }

  .number-metric-display-button {
    font-size: 4rem;
  }

  .benefits-section-bg-2.bg_img {
    width: 100%;
    height: 100%;
    top: 0px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
    background-size: cover;
  }
}

@media only screen and (max-width: 1439px) and (min-width: 1025px) {
  .benefits-section-bg-2.bg_img {
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
    background-size: cover;
  }
}

@media only screen and (max-width: 1439px) and (min-width: 1026px) {
  .benefits-section-bg {
    width: 65%;
    height: 100%;
    top: -90px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
    z-index: 1;
  }

  .benefits-section-bg-1 {
    width: 85%;
    height: 100%;
    top: -90px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
    z-index: 1;
  }
}

.wrapper {
  transform: translate(-0%, -0%);
}

.btn-apply {
  display: block;
  text-decoration: none;
  text-align: center;
  border-radius: 50px;
  border: 3px solid #ceae7b;
  color: #ceae7b;
  font-family: arial;
  position: relative;
  overflow: hidden;
  background: transparent;
  text-transform: uppercase;
  transition: all .35s;
  padding: 10px 20px;
}

.btn-apply:before,
.btn-apply:after {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  top: -100%;
  left: 0;
  background: #ceae7b;
  z-index: -1;
  transition: all .35s;
}

.btn-apply:before {
  opacity: .5;
}

.btn-apply:after {
  transition-delay: .2s;
}

.btn-apply:hover {
  color: #161616;
  border: 0px solid #ceae7b;
  font-weight: 600;
}

.btn-apply:hover:before,
.btn-apply:hover:after {
  top: 0;
}

.content {
  height: 100vh;
}

.text-content {
  position: absolute;
  top: 50%;
  left: 50%;
  padding: 5px 15px;
  transform: translate(-50%, -50%);
  background: gray;
  color: white;
  border-radius: 20px;
  font-size: 50px;
}

.parallax_section {
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.parallax_bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  z-index: -1;
  min-height: 100%;
  transform: translate3d(0, 0, -1px) scale(2);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.parallax_bg_1 {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  z-index: -1;
  min-height: 100%;
  width: 100%;
  height: 100%;
}

.parallax_bg_1.parallax_img {
  /* background-image: url(./assets/New-Xure-Logo.png); */
  /* background-image: url(./assets/bg/bg-section-7.png); */
  /* background-image: url(./assets/section-asset/asset-gif-3.mp4); */
  background-position: center center;
  background-repeat: no-repeat;
  opacity: 20%;
  filter: blur(5px);
}

.swipe-section {
  position: relative;
  overflow: hidden;
}

.panel {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2rem;
}

#mobile-nav {
  /* background-image: url(./assets/bg/bg-nav.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover; */
  background-image: linear-gradient(135deg,
      hsl(0deg 0% 2%) 12%,
      hsl(37deg 25% 13%) 63%,
      hsl(37deg 25% 19%) 74%,
      hsl(37deg 25% 23%) 80%,
      hsl(37deg 25% 26%) 84%,
      hsl(37deg 25% 30%) 88%,
      hsl(37deg 25% 32%) 90%,
      hsl(37deg 25% 35%) 92%,
      hsl(37deg 25% 37%) 94%,
      hsl(37deg 25% 40%) 95%,
      hsl(37deg 25% 42%) 96%,
      hsl(37deg 25% 44%) 97%,
      hsl(37deg 25% 46%) 98%,
      hsl(37deg 25% 48%) 99%,
      hsl(37deg 25% 49%) 99%,
      hsl(37deg 26% 51%) 100%,
      hsl(37deg 28% 53%) 100%,
      hsl(37deg 30% 54%) 100%,
      hsl(37deg 32% 56%) 100%,
      hsl(37deg 34% 57%) 100%,
      hsl(37deg 36% 59%) 100%,
      hsl(37deg 38% 60%) 100%,
      hsl(37deg 41% 62%) 100%,
      hsl(37deg 43% 63%) 100%,
      hsl(37deg 46% 65%) 100%);
}

.fade-in {
  animation: fadeIn 0.7s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

#loader-container {
  max-width: 100%;
  position: absolute;
  height: 100%;
  background-color: #161616;
}

.dialog-body-scroll {
  max-height: calc(90vh - 100px);
  /* Adjust to your needs */
  overflow-y: scroll;
  /* Always show a scrollbar */
  -webkit-overflow-scrolling: touch;
  /* Enable smooth scrolling on touch devices */
  touch-action: pan-y;
  /* Ensures smooth vertical scrolling on touch devices */
  scroll-behavior: smooth;
  /* Smooth scrolling */
  position: relative;
  /* Helps ensure the element is scrollable */
  display: flex;
  /* Ensures proper internal layout for the scrollable content */
  flex-direction: column;
}

.placeholder\\:font-\\[500\\]::placeholder {
  font-weight: 500;
}

.before\\:pointer-events-none::before {
  content: var(--tw-content);
  pointer-events: none;
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:left-2\\/4::before {
  content: var(--tw-content);
  left: 50%;
}

.before\\:top-2\\/4::before {
  content: var(--tw-content);
  top: 50%;
}

.before\\:mr-1::before {
  content: var(--tw-content);
  margin-right: 0.25rem;
}

.before\\:mt-\\[6\\.5px\\]::before {
  content: var(--tw-content);
  margin-top: 6.5px;
}

.before\\:box-border::before {
  content: var(--tw-content);
  box-sizing: border-box;
}

.before\\:block::before {
  content: var(--tw-content);
  display: block;
}

.before\\:h-1::before {
  content: var(--tw-content);
  height: 0.25rem;
}

.before\\:h-1\\.5::before {
  content: var(--tw-content);
  height: 0.375rem;
}

.before\\:h-10::before {
  content: var(--tw-content);
  height: 2.5rem;
}

.before\\:h-12::before {
  content: var(--tw-content);
  height: 3rem;
}

.before\\:w-10::before {
  content: var(--tw-content);
  width: 2.5rem;
}

.before\\:w-12::before {
  content: var(--tw-content);
  width: 3rem;
}

.before\\:w-2::before {
  content: var(--tw-content);
  width: 0.5rem;
}

.before\\:w-2\\.5::before {
  content: var(--tw-content);
  width: 0.625rem;
}

.before\\:-translate-x-2\\/4::before {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:-translate-y-2\\/4::before {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:rounded-full::before {
  content: var(--tw-content);
  border-radius: 9999px;
}

.before\\:rounded-tl-md::before {
  content: var(--tw-content);
  border-top-left-radius: 0.375rem;
}

.before\\:border-l::before {
  content: var(--tw-content);
  border-left-width: 1px;
}

.before\\:border-l-2::before {
  content: var(--tw-content);
  border-left-width: 2px;
}

.before\\:border-t::before {
  content: var(--tw-content);
  border-top-width: 1px;
}

.before\\:border-t-2::before {
  content: var(--tw-content);
  border-top-width: 2px;
}

.before\\:\\!border-blue-gray-200::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(176 190 197 / var(--tw-border-opacity)) !important;
}

.before\\:border-amber-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.before\\:border-black::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.before\\:border-blue-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(63 131 248 / var(--tw-border-opacity));
}

.before\\:border-blue-gray-200::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}

.before\\:border-blue-gray-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.before\\:border-brown-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.before\\:border-cyan-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.before\\:border-deep-orange-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.before\\:border-deep-purple-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.before\\:border-gray-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}

.before\\:border-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity));
}

.before\\:border-indigo-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(104 117 245 / var(--tw-border-opacity));
}

.before\\:border-light-blue-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.before\\:border-light-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.before\\:border-lime-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.before\\:border-orange-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 90 31 / var(--tw-border-opacity));
}

.before\\:border-pink-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(231 70 148 / var(--tw-border-opacity));
}

.before\\:border-purple-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(144 97 249 / var(--tw-border-opacity));
}

.before\\:border-red-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity));
}

.before\\:border-teal-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(6 148 162 / var(--tw-border-opacity));
}

.before\\:border-transparent::before {
  content: var(--tw-content);
  border-color: transparent;
}

.before\\:border-white::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.before\\:border-yellow-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(194 120 3 / var(--tw-border-opacity));
}

.before\\:border-l-transparent::before {
  content: var(--tw-content);
  border-left-color: transparent;
}

.before\\:border-t-transparent::before {
  content: var(--tw-content);
  border-top-color: transparent;
}

.before\\:bg-blue-gray-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}

.before\\:opacity-0::before {
  content: var(--tw-content);
  opacity: 0;
}

.before\\:transition-all::before {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.before\\:transition-opacity::before {
  content: var(--tw-content);
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:pointer-events-none::after {
  content: var(--tw-content);
  pointer-events: none;
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:-bottom-0::after {
  content: var(--tw-content);
  bottom: -0px;
}

.after\\:-bottom-1::after {
  content: var(--tw-content);
  bottom: -0.25rem;
}

.after\\:-bottom-1\\.5::after {
  content: var(--tw-content);
  bottom: -0.375rem;
}

.after\\:-bottom-2::after {
  content: var(--tw-content);
  bottom: -0.5rem;
}

.after\\:-bottom-2\\.5::after {
  content: var(--tw-content);
  bottom: -0.625rem;
}

.after\\:left-1::after {
  content: var(--tw-content);
  left: 0.25rem;
}

.after\\:left-px::after {
  content: var(--tw-content);
  left: 1px;
}

.after\\:top-0::after {
  content: var(--tw-content);
  top: 0px;
}

.after\\:top-0\\.5::after {
  content: var(--tw-content);
  top: 0.125rem;
}

.after\\:top-px::after {
  content: var(--tw-content);
  top: 1px;
}

.after\\:ml-1::after {
  content: var(--tw-content);
  margin-left: 0.25rem;
}

.after\\:mt-\\[6\\.5px\\]::after {
  content: var(--tw-content);
  margin-top: 6.5px;
}

.after\\:box-border::after {
  content: var(--tw-content);
  box-sizing: border-box;
}

.after\\:block::after {
  content: var(--tw-content);
  display: block;
}

.after\\:h-1::after {
  content: var(--tw-content);
  height: 0.25rem;
}

.after\\:h-1\\.5::after {
  content: var(--tw-content);
  height: 0.375rem;
}

.after\\:h-4::after {
  content: var(--tw-content);
  height: 1rem;
}

.after\\:h-5::after {
  content: var(--tw-content);
  height: 1.25rem;
}

.after\\:h-6::after {
  content: var(--tw-content);
  height: 1.5rem;
}

.after\\:w-2::after {
  content: var(--tw-content);
  width: 0.5rem;
}

.after\\:w-2\\.5::after {
  content: var(--tw-content);
  width: 0.625rem;
}

.after\\:w-4::after {
  content: var(--tw-content);
  width: 1rem;
}

.after\\:w-5::after {
  content: var(--tw-content);
  width: 1.25rem;
}

.after\\:w-6::after {
  content: var(--tw-content);
  width: 1.5rem;
}

.after\\:w-full::after {
  content: var(--tw-content);
  width: 100%;
}

.after\\:flex-grow::after {
  content: var(--tw-content);
  flex-grow: 1;
}

.after\\:translate-x-full::after {
  content: var(--tw-content);
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:scale-x-0::after {
  content: var(--tw-content);
  --tw-scale-x: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:scale-x-100::after {
  content: var(--tw-content);
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:rounded-full::after {
  content: var(--tw-content);
  border-radius: 9999px;
}

.after\\:rounded-tr-md::after {
  content: var(--tw-content);
  border-top-right-radius: 0.375rem;
}

.after\\:border-b-2::after {
  content: var(--tw-content);
  border-bottom-width: 2px;
}

.after\\:border-r::after {
  content: var(--tw-content);
  border-right-width: 1px;
}

.after\\:border-r-2::after {
  content: var(--tw-content);
  border-right-width: 2px;
}

.after\\:border-t::after {
  content: var(--tw-content);
  border-top-width: 1px;
}

.after\\:border-t-2::after {
  content: var(--tw-content);
  border-top-width: 2px;
}

.after\\:\\!border-blue-gray-200::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(176 190 197 / var(--tw-border-opacity)) !important;
}

.after\\:border-amber-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.after\\:border-black::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.after\\:border-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(63 131 248 / var(--tw-border-opacity));
}

.after\\:border-blue-gray-200::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}

.after\\:border-blue-gray-50::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(236 239 241 / var(--tw-border-opacity));
}

.after\\:border-blue-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.after\\:border-brown-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.after\\:border-cyan-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.after\\:border-deep-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.after\\:border-deep-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.after\\:border-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}

.after\\:border-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity));
}

.after\\:border-indigo-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(104 117 245 / var(--tw-border-opacity));
}

.after\\:border-light-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.after\\:border-light-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.after\\:border-lime-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.after\\:border-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 90 31 / var(--tw-border-opacity));
}

.after\\:border-pink-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(231 70 148 / var(--tw-border-opacity));
}

.after\\:border-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(144 97 249 / var(--tw-border-opacity));
}

.after\\:border-red-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity));
}

.after\\:border-teal-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(6 148 162 / var(--tw-border-opacity));
}

.after\\:border-transparent::after {
  content: var(--tw-content);
  border-color: transparent;
}

.after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.after\\:border-yellow-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(194 120 3 / var(--tw-border-opacity));
}

.after\\:border-r-transparent::after {
  content: var(--tw-content);
  border-right-color: transparent;
}

.after\\:border-t-transparent::after {
  content: var(--tw-content);
  border-top-color: transparent;
}

.after\\:bg-white::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.after\\:transition-all::after {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:transition-transform::after {
  content: var(--tw-content);
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.after\\:duration-300::after {
  content: var(--tw-content);
  transition-duration: 300ms;
}

.first\\:ml-0:first-child {
  margin-left: 0px;
}

.first\\:mt-0:first-child {
  margin-top: 0px;
}

.first\\:rounded-t-lg:first-child {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.first\\:border-t-0:first-child {
  border-top-width: 0px;
}

.first\\:pt-0:first-child {
  padding-top: 0px;
}

.last\\:mr-0:last-child {
  margin-right: 0px;
}

.last\\:rounded-b-lg:last-child {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.odd\\:bg-white:nth-child(odd) {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.even\\:bg-gray-50:nth-child(even) {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}

.checked\\:border-amber-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.checked\\:border-blue-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(63 131 248 / var(--tw-border-opacity));
}

.checked\\:border-blue-gray-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.checked\\:border-brown-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.checked\\:border-cyan-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.checked\\:border-deep-orange-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.checked\\:border-deep-purple-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.checked\\:border-gray-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}

.checked\\:border-green-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity));
}

.checked\\:border-indigo-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(104 117 245 / var(--tw-border-opacity));
}

.checked\\:border-light-blue-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.checked\\:border-light-green-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.checked\\:border-lime-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.checked\\:border-orange-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(255 90 31 / var(--tw-border-opacity));
}

.checked\\:border-pink-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(231 70 148 / var(--tw-border-opacity));
}

.checked\\:border-purple-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(144 97 249 / var(--tw-border-opacity));
}

.checked\\:border-red-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity));
}

.checked\\:border-teal-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(6 148 162 / var(--tw-border-opacity));
}

.checked\\:border-yellow-500:checked {
  --tw-border-opacity: 1;
  border-color: rgb(194 120 3 / var(--tw-border-opacity));
}

.checked\\:bg-amber-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}

.checked\\:bg-blue-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(63 131 248 / var(--tw-bg-opacity));
}

.checked\\:bg-blue-gray-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}

.checked\\:bg-brown-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}

.checked\\:bg-cyan-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}

.checked\\:bg-deep-orange-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}

.checked\\:bg-deep-purple-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}

.checked\\:bg-gray-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}

.checked\\:bg-green-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(14 159 110 / var(--tw-bg-opacity));
}

.checked\\:bg-indigo-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(104 117 245 / var(--tw-bg-opacity));
}

.checked\\:bg-light-blue-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}

.checked\\:bg-light-green-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}

.checked\\:bg-lime-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}

.checked\\:bg-orange-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(255 90 31 / var(--tw-bg-opacity));
}

.checked\\:bg-pink-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(231 70 148 / var(--tw-bg-opacity));
}

.checked\\:bg-purple-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(144 97 249 / var(--tw-bg-opacity));
}

.checked\\:bg-red-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(240 82 82 / var(--tw-bg-opacity));
}

.checked\\:bg-teal-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(6 148 162 / var(--tw-bg-opacity));
}

.checked\\:bg-yellow-500:checked {
  --tw-bg-opacity: 1;
  background-color: rgb(194 120 3 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-amber-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-blue-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(63 131 248 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-blue-gray-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-brown-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-cyan-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-deep-orange-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-deep-purple-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-gray-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-green-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(14 159 110 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-indigo-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(104 117 245 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-light-blue-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-light-green-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-lime-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-orange-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 90 31 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-pink-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(231 70 148 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-purple-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(144 97 249 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-red-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(240 82 82 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-teal-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(6 148 162 / var(--tw-bg-opacity));
}

.checked\\:before\\:bg-yellow-500:checked::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(194 120 3 / var(--tw-bg-opacity));
}

.placeholder-shown\\:border:placeholder-shown {
  border-width: 1px;
}

.placeholder-shown\\:border-blue-gray-200:placeholder-shown {
  --tw-border-opacity: 1;
  border-color: rgb(176 190 197 / var(--tw-border-opacity));
}

.placeholder-shown\\:border-green-500:placeholder-shown {
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity));
}

.placeholder-shown\\:border-red-500:placeholder-shown {
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity));
}

.placeholder-shown\\:border-t-blue-gray-200:placeholder-shown {
  --tw-border-opacity: 1;
  border-top-color: rgb(176 190 197 / var(--tw-border-opacity));
}

.placeholder-shown\\:border-t-green-500:placeholder-shown {
  --tw-border-opacity: 1;
  border-top-color: rgb(14 159 110 / var(--tw-border-opacity));
}

.placeholder-shown\\:border-t-red-500:placeholder-shown {
  --tw-border-opacity: 1;
  border-top-color: rgb(240 82 82 / var(--tw-border-opacity));
}

.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:cursor-not-allowed:hover {
  cursor: not-allowed;
}

.hover\\:border-gray-300:hover {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}

.hover\\:border-white:hover {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.hover\\:bg-\\[\\#ceae7b\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(206 174 123 / var(--tw-bg-opacity));
}

.hover\\:bg-amber-500\\/10:hover {
  background-color: rgb(255 193 7 / 0.1);
}

.hover\\:bg-blue-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(195 221 253 / var(--tw-bg-opacity));
}

.hover\\:bg-blue-500\\/10:hover {
  background-color: rgb(63 131 248 / 0.1);
}

.hover\\:bg-blue-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 66 159 / var(--tw-bg-opacity));
}

.hover\\:bg-blue-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}

.hover\\:bg-blue-gray-500\\/10:hover {
  background-color: rgb(96 125 139 / 0.1);
}

.hover\\:bg-brown-500\\/10:hover {
  background-color: rgb(121 85 72 / 0.1);
}

.hover\\:bg-cyan-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(178 235 242 / var(--tw-bg-opacity));
}

.hover\\:bg-cyan-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(128 222 234 / var(--tw-bg-opacity));
}

.hover\\:bg-cyan-500\\/10:hover {
  background-color: rgb(0 188 212 / 0.1);
}

.hover\\:bg-cyan-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 172 193 / var(--tw-bg-opacity));
}

.hover\\:bg-cyan-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 131 143 / var(--tw-bg-opacity));
}

.hover\\:bg-deep-orange-500\\/10:hover {
  background-color: rgb(255 87 34 / 0.1);
}

.hover\\:bg-deep-purple-500\\/10:hover {
  background-color: rgb(103 58 183 / 0.1);
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-500\\/10:hover {
  background-color: rgb(107 114 128 / 0.1);
}

.hover\\:bg-gray-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}

.hover\\:bg-green-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(188 240 218 / var(--tw-bg-opacity));
}

.hover\\:bg-green-500\\/10:hover {
  background-color: rgb(14 159 110 / 0.1);
}

.hover\\:bg-indigo-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(205 219 254 / var(--tw-bg-opacity));
}

.hover\\:bg-indigo-500\\/10:hover {
  background-color: rgb(104 117 245 / 0.1);
}

.hover\\:bg-light-blue-500\\/10:hover {
  background-color: rgb(3 169 244 / 0.1);
}

.hover\\:bg-light-green-500\\/10:hover {
  background-color: rgb(139 195 74 / 0.1);
}

.hover\\:bg-lime-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(230 238 156 / var(--tw-bg-opacity));
}

.hover\\:bg-lime-500\\/10:hover {
  background-color: rgb(205 220 57 / 0.1);
}

.hover\\:bg-orange-500\\/10:hover {
  background-color: rgb(255 90 31 / 0.1);
}

.hover\\:bg-pink-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 209 232 / var(--tw-bg-opacity));
}

.hover\\:bg-pink-500\\/10:hover {
  background-color: rgb(231 70 148 / 0.1);
}

.hover\\:bg-purple-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 215 254 / var(--tw-bg-opacity));
}

.hover\\:bg-purple-500\\/10:hover {
  background-color: rgb(144 97 249 / 0.1);
}

.hover\\:bg-red-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(251 213 213 / var(--tw-bg-opacity));
}

.hover\\:bg-red-500\\/10:hover {
  background-color: rgb(240 82 82 / 0.1);
}

.hover\\:bg-teal-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(175 236 239 / var(--tw-bg-opacity));
}

.hover\\:bg-teal-500\\/10:hover {
  background-color: rgb(6 148 162 / 0.1);
}

.hover\\:bg-transparent:hover {
  background-color: transparent;
}

.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}

.hover\\:bg-yellow-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(252 233 106 / var(--tw-bg-opacity));
}

.hover\\:bg-yellow-500\\/10:hover {
  background-color: rgb(194 120 3 / 0.1);
}

.hover\\:bg-opacity-80:hover {
  --tw-bg-opacity: 0.8;
}

.hover\\:bg-gradient-to-br:hover {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.hover\\:text-\\[\\#ceae7b\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(206 174 123 / var(--tw-text-opacity));
}

.hover\\:text-blue-gray-500:hover {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

.hover\\:text-blue-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}

.hover\\:text-cyan-700:hover {
  --tw-text-opacity: 1;
  color: rgb(0 151 167 / var(--tw-text-opacity));
}

.hover\\:text-gray-200:hover {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}

.hover\\:text-gray-600:hover {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}

.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}

.hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}

.hover\\:text-light-blue-500:hover {
  --tw-text-opacity: 1;
  color: rgb(3 169 244 / var(--tw-text-opacity));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-75:hover {
  opacity: 0.75;
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-amber-500\\/40:hover {
  --tw-shadow-color: rgb(255 193 7 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-blue-500\\/40:hover {
  --tw-shadow-color: rgb(63 131 248 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-blue-gray-500\\/20:hover {
  --tw-shadow-color: rgb(96 125 139 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-blue-gray-500\\/40:hover {
  --tw-shadow-color: rgb(96 125 139 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-brown-500\\/40:hover {
  --tw-shadow-color: rgb(121 85 72 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-cyan-500\\/40:hover {
  --tw-shadow-color: rgb(0 188 212 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-deep-orange-500\\/40:hover {
  --tw-shadow-color: rgb(255 87 34 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-deep-purple-500\\/40:hover {
  --tw-shadow-color: rgb(103 58 183 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-gray-500\\/40:hover {
  --tw-shadow-color: rgb(107 114 128 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-green-500\\/40:hover {
  --tw-shadow-color: rgb(14 159 110 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-indigo-500\\/40:hover {
  --tw-shadow-color: rgb(104 117 245 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-light-blue-500\\/40:hover {
  --tw-shadow-color: rgb(3 169 244 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-light-green-500\\/40:hover {
  --tw-shadow-color: rgb(139 195 74 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-lime-500\\/40:hover {
  --tw-shadow-color: rgb(205 220 57 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-orange-500\\/40:hover {
  --tw-shadow-color: rgb(255 90 31 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-pink-500\\/40:hover {
  --tw-shadow-color: rgb(231 70 148 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-purple-500\\/40:hover {
  --tw-shadow-color: rgb(144 97 249 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-red-500\\/40:hover {
  --tw-shadow-color: rgb(240 82 82 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-teal-500\\/40:hover {
  --tw-shadow-color: rgb(6 148 162 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-yellow-500\\/40:hover {
  --tw-shadow-color: rgb(194 120 3 / 0.4);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:before\\:opacity-10:hover::before {
  content: var(--tw-content);
  opacity: 0.1;
}

.focus\\:z-10:focus {
  z-index: 10;
}

.focus\\:scale-110:focus {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.focus\\:border-2:focus {
  border-width: 2px;
}

.focus\\:border-\\[\\#ceae7b\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(206 174 123 / var(--tw-border-opacity));
}

.focus\\:border-amber-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.focus\\:border-black:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(63 131 248 / var(--tw-border-opacity));
}

.focus\\:border-blue-600:focus {
  --tw-border-opacity: 1;
  border-color: rgb(28 100 242 / var(--tw-border-opacity));
}

.focus\\:border-blue-gray-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.focus\\:border-brown-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.focus\\:border-cyan-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.focus\\:border-deep-orange-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.focus\\:border-deep-purple-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.focus\\:border-gray-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}

.focus\\:border-green-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity));
}

.focus\\:border-green-600:focus {
  --tw-border-opacity: 1;
  border-color: rgb(5 122 85 / var(--tw-border-opacity));
}

.focus\\:border-indigo-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(104 117 245 / var(--tw-border-opacity));
}

.focus\\:border-light-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.focus\\:border-light-green-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.focus\\:border-lime-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.focus\\:border-orange-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 90 31 / var(--tw-border-opacity));
}

.focus\\:border-pink-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(231 70 148 / var(--tw-border-opacity));
}

.focus\\:border-purple-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(144 97 249 / var(--tw-border-opacity));
}

.focus\\:border-red-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity));
}

.focus\\:border-red-600:focus {
  --tw-border-opacity: 1;
  border-color: rgb(224 36 36 / var(--tw-border-opacity));
}

.focus\\:border-teal-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(6 148 162 / var(--tw-border-opacity));
}

.focus\\:border-white:focus {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.focus\\:border-yellow-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(194 120 3 / var(--tw-border-opacity));
}

.focus\\:border-t-transparent:focus {
  border-top-color: transparent;
}

.focus\\:bg-blue-gray-50:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}

.focus\\:bg-gray-100:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.focus\\:bg-transparent:focus {
  background-color: transparent;
}

.focus\\:bg-opacity-80:focus {
  --tw-bg-opacity: 0.8;
}

.focus\\:text-blue-gray-500:focus {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

.focus\\:text-blue-gray-900:focus {
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}

.focus\\:text-cyan-700:focus {
  --tw-text-opacity: 1;
  color: rgb(0 151 167 / var(--tw-text-opacity));
}

.focus\\:text-gray-900:focus {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}

.focus\\:opacity-\\[0\\.85\\]:focus {
  opacity: 0.85;
}

.focus\\:shadow-none:focus {
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:outline-0:focus {
  outline-width: 0px;
}

.focus\\:ring:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-4:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-\\[\\#ceae7b\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(206 174 123 / var(--tw-ring-opacity));
}

.focus\\:ring-amber-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 224 130 / var(--tw-ring-opacity));
}

.focus\\:ring-blue-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(195 221 253 / var(--tw-ring-opacity));
}

.focus\\:ring-blue-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(164 202 254 / var(--tw-ring-opacity));
}

.focus\\:ring-blue-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(118 169 250 / var(--tw-ring-opacity));
}

.focus\\:ring-blue-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(28 100 242 / var(--tw-ring-opacity));
}

.focus\\:ring-blue-gray-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(176 190 197 / var(--tw-ring-opacity));
}

.focus\\:ring-brown-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(188 170 164 / var(--tw-ring-opacity));
}

.focus\\:ring-cyan-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(128 222 234 / var(--tw-ring-opacity));
}

.focus\\:ring-cyan-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(77 208 225 / var(--tw-ring-opacity));
}

.focus\\:ring-cyan-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(38 198 218 / var(--tw-ring-opacity));
}

.focus\\:ring-cyan-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 188 212 / var(--tw-ring-opacity));
}

.focus\\:ring-cyan-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 172 193 / var(--tw-ring-opacity));
}

.focus\\:ring-cyan-700:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 151 167 / var(--tw-ring-opacity));
}

.focus\\:ring-cyan-800:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 131 143 / var(--tw-ring-opacity));
}

.focus\\:ring-deep-orange-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 171 145 / var(--tw-ring-opacity));
}

.focus\\:ring-deep-purple-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(179 157 219 / var(--tw-ring-opacity));
}

.focus\\:ring-gray-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity));
}

.focus\\:ring-gray-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(209 213 219 / var(--tw-ring-opacity));
}

.focus\\:ring-gray-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity));
}

.focus\\:ring-gray-800:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(31 41 55 / var(--tw-ring-opacity));
}

.focus\\:ring-gray-900:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(17 24 39 / var(--tw-ring-opacity));
}

.focus\\:ring-green-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(188 240 218 / var(--tw-ring-opacity));
}

.focus\\:ring-green-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(132 225 188 / var(--tw-ring-opacity));
}

.focus\\:ring-green-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(49 196 141 / var(--tw-ring-opacity));
}

.focus\\:ring-green-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 159 110 / var(--tw-ring-opacity));
}

.focus\\:ring-green-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 122 85 / var(--tw-ring-opacity));
}

.focus\\:ring-green-800:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(3 84 63 / var(--tw-ring-opacity));
}

.focus\\:ring-indigo-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(205 219 254 / var(--tw-ring-opacity));
}

.focus\\:ring-indigo-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(180 198 252 / var(--tw-ring-opacity));
}

.focus\\:ring-indigo-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(141 162 251 / var(--tw-ring-opacity));
}

.focus\\:ring-indigo-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(88 80 236 / var(--tw-ring-opacity));
}

.focus\\:ring-indigo-700:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(81 69 205 / var(--tw-ring-opacity));
}

.focus\\:ring-light-blue-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 212 250 / var(--tw-ring-opacity));
}

.focus\\:ring-light-green-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(197 225 165 / var(--tw-ring-opacity));
}

.focus\\:ring-lime-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(230 238 156 / var(--tw-ring-opacity));
}

.focus\\:ring-lime-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(220 231 117 / var(--tw-ring-opacity));
}

.focus\\:ring-lime-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(212 225 87 / var(--tw-ring-opacity));
}

.focus\\:ring-lime-700:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(175 180 43 / var(--tw-ring-opacity));
}

.focus\\:ring-orange-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 217 189 / var(--tw-ring-opacity));
}

.focus\\:ring-pink-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 209 232 / var(--tw-ring-opacity));
}

.focus\\:ring-pink-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 180 217 / var(--tw-ring-opacity));
}

.focus\\:ring-pink-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(241 126 184 / var(--tw-ring-opacity));
}

.focus\\:ring-pink-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(214 31 105 / var(--tw-ring-opacity));
}

.focus\\:ring-purple-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(220 215 254 / var(--tw-ring-opacity));
}

.focus\\:ring-purple-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(202 191 253 / var(--tw-ring-opacity));
}

.focus\\:ring-purple-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(172 148 250 / var(--tw-ring-opacity));
}

.focus\\:ring-purple-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 58 242 / var(--tw-ring-opacity));
}

.focus\\:ring-red-100:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 232 232 / var(--tw-ring-opacity));
}

.focus\\:ring-red-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(251 213 213 / var(--tw-ring-opacity));
}

.focus\\:ring-red-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 180 180 / var(--tw-ring-opacity));
}

.focus\\:ring-red-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(249 128 128 / var(--tw-ring-opacity));
}

.focus\\:ring-red-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(240 82 82 / var(--tw-ring-opacity));
}

.focus\\:ring-red-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 36 36 / var(--tw-ring-opacity));
}

.focus\\:ring-red-900:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(119 29 29 / var(--tw-ring-opacity));
}

.focus\\:ring-teal-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(175 236 239 / var(--tw-ring-opacity));
}

.focus\\:ring-teal-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 220 226 / var(--tw-ring-opacity));
}

.focus\\:ring-teal-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(22 189 202 / var(--tw-ring-opacity));
}

.focus\\:ring-teal-600:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(4 116 129 / var(--tw-ring-opacity));
}

.focus\\:ring-white\\/50:focus {
  --tw-ring-color: rgb(255 255 255 / 0.5);
}

.focus\\:ring-yellow-200:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 233 106 / var(--tw-ring-opacity));
}

.focus\\:ring-yellow-300:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(250 202 21 / var(--tw-ring-opacity));
}

.focus\\:ring-yellow-400:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(227 160 8 / var(--tw-ring-opacity));
}

.focus\\:ring-yellow-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(194 120 3 / var(--tw-ring-opacity));
}

.active\\:scale-100:active {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:bg-amber-500\\/30:active {
  background-color: rgb(255 193 7 / 0.3);
}

.active\\:bg-blue-500\\/30:active {
  background-color: rgb(63 131 248 / 0.3);
}

.active\\:bg-blue-gray-50:active {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}

.active\\:bg-blue-gray-500\\/30:active {
  background-color: rgb(96 125 139 / 0.3);
}

.active\\:bg-brown-500\\/30:active {
  background-color: rgb(121 85 72 / 0.3);
}

.active\\:bg-cyan-500\\/30:active {
  background-color: rgb(0 188 212 / 0.3);
}

.active\\:bg-deep-orange-500\\/30:active {
  background-color: rgb(255 87 34 / 0.3);
}

.active\\:bg-deep-purple-500\\/30:active {
  background-color: rgb(103 58 183 / 0.3);
}

.active\\:bg-gray-500\\/30:active {
  background-color: rgb(107 114 128 / 0.3);
}

.active\\:bg-green-500\\/30:active {
  background-color: rgb(14 159 110 / 0.3);
}

.active\\:bg-indigo-500\\/30:active {
  background-color: rgb(104 117 245 / 0.3);
}

.active\\:bg-light-blue-500\\/30:active {
  background-color: rgb(3 169 244 / 0.3);
}

.active\\:bg-light-green-500\\/30:active {
  background-color: rgb(139 195 74 / 0.3);
}

.active\\:bg-lime-500\\/30:active {
  background-color: rgb(205 220 57 / 0.3);
}

.active\\:bg-orange-500\\/30:active {
  background-color: rgb(255 90 31 / 0.3);
}

.active\\:bg-pink-500\\/30:active {
  background-color: rgb(231 70 148 / 0.3);
}

.active\\:bg-purple-500\\/30:active {
  background-color: rgb(144 97 249 / 0.3);
}

.active\\:bg-red-500\\/30:active {
  background-color: rgb(240 82 82 / 0.3);
}

.active\\:bg-teal-500\\/30:active {
  background-color: rgb(6 148 162 / 0.3);
}

.active\\:bg-transparent:active {
  background-color: transparent;
}

.active\\:bg-white\\/30:active {
  background-color: rgb(255 255 255 / 0.3);
}

.active\\:bg-yellow-500\\/30:active {
  background-color: rgb(194 120 3 / 0.3);
}

.active\\:bg-opacity-80:active {
  --tw-bg-opacity: 0.8;
}

.active\\:text-blue-gray-500:active {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

.active\\:text-blue-gray-900:active {
  --tw-text-opacity: 1;
  color: rgb(38 50 56 / var(--tw-text-opacity));
}

.active\\:opacity-\\[0\\.85\\]:active {
  opacity: 0.85;
}

.active\\:shadow-none:active {
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.enabled\\:hover\\:bg-blue-800:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(30 66 159 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-cyan-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(178 235 242 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-cyan-800:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(0 131 143 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-gray-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-gray-900:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-green-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(222 247 236 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-green-800:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(3 84 63 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-indigo-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(229 237 255 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-lime-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(240 244 195 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-pink-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(252 232 243 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-purple-800:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(85 33 181 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-red-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(253 232 232 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-red-800:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(155 28 28 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-teal-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(213 245 246 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-yellow-100:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(253 246 178 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-yellow-500:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(194 120 3 / var(--tw-bg-opacity));
}

.enabled\\:hover\\:bg-gradient-to-bl:hover:enabled {
  background-image: linear-gradient(to bottom left, var(--tw-gradient-stops));
}

.enabled\\:hover\\:bg-gradient-to-br:hover:enabled {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.enabled\\:hover\\:bg-gradient-to-l:hover:enabled {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}

.enabled\\:hover\\:from-teal-200:hover:enabled {
  --tw-gradient-from: #AFECEF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(175 236 239 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.enabled\\:hover\\:to-lime-200:hover:enabled {
  --tw-gradient-to: #e6ee9c var(--tw-gradient-to-position);
}

.enabled\\:hover\\:text-cyan-700:hover:enabled {
  --tw-text-opacity: 1;
  color: rgb(0 151 167 / var(--tw-text-opacity));
}

.enabled\\:hover\\:text-gray-700:hover:enabled {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}

.enabled\\:hover\\:text-gray-900:hover:enabled {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}

.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:resize-none:disabled {
  resize: none;
}

.disabled\\:border-0:disabled {
  border-width: 0px;
}

.disabled\\:bg-blue-gray-50:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(236 239 241 / var(--tw-bg-opacity));
}

.disabled\\:text-gray-400:disabled {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.disabled\\:shadow-none:disabled {
  --tw-shadow: 0 0 rgb(0, 0 / 0, 0);
  --tw-shadow-colored: 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:first-child .group-first\\:hidden {
  display: none;
}

.group\\/body:first-child .group\\/row:first-child .group-first\\/body\\:group-first\\/row\\:first\\:rounded-tl-lg:first-child {
  border-top-left-radius: 0.5rem;
}

.group\\/head:first-child .group-first\\/head\\:first\\:rounded-tl-lg:first-child {
  border-top-left-radius: 0.5rem;
}

.group\\/body:first-child .group\\/row:first-child .group-first\\/body\\:group-first\\/row\\:last\\:rounded-tr-lg:last-child {
  border-top-right-radius: 0.5rem;
}

.group\\/head:first-child .group-first\\/head\\:last\\:rounded-tr-lg:last-child {
  border-top-right-radius: 0.5rem;
}

.group\\/body:last-child .group\\/row:last-child .group-last\\/body\\:group-last\\/row\\:first\\:rounded-bl-lg:first-child {
  border-bottom-left-radius: 0.5rem;
}

.group\\/body:last-child .group\\/row:last-child .group-last\\/body\\:group-last\\/row\\:last\\:rounded-br-lg:last-child {
  border-bottom-right-radius: 0.5rem;
}

.group:hover .group-hover\\:bg-blue-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(195 221 253 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-cyan-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(128 222 234 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-green-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(188 240 218 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-indigo-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(205 219 254 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-lime-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(230 238 156 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-pink-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 209 232 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-purple-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 215 254 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-red-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 213 213 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-teal-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(175 236 239 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}

.group:hover .group-hover\\:bg-yellow-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 233 106 / var(--tw-bg-opacity));
}

.group:hover .group-hover\\:text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}

.group:focus .group-focus\\:outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.group:focus .group-focus\\:ring-4 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.group:focus .group-focus\\:ring-cyan-500\\/25 {
  --tw-ring-color: rgb(0 188 212 / 0.25);
}

.group:focus .group-focus\\:ring-white {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity));
}

.group:enabled:hover .group-enabled\\:group-hover\\:bg-opacity-0 {
  --tw-bg-opacity: 0;
}

.group:enabled:hover .group-enabled\\:group-hover\\:text-inherit {
  color: inherit;
}

.peer:checked ~ .peer-checked\\:translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:checked ~ .peer-checked\\:border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(63 131 248 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-blue-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-brown-500 {
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-cyan-500 {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-deep-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-deep-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(104 117 245 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-light-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-light-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-lime-500 {
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(255 90 31 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-pink-500 {
  --tw-border-opacity: 1;
  border-color: rgb(231 70 148 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-purple-500 {
  --tw-border-opacity: 1;
  border-color: rgb(144 97 249 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-teal-500 {
  --tw-border-opacity: 1;
  border-color: rgb(6 148 162 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(194 120 3 / var(--tw-border-opacity));
}

.peer:checked ~ .peer-checked\\:opacity-100 {
  opacity: 1;
}

.peer:checked ~ .peer-checked\\:before\\:bg-amber-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 193 7 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-blue-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(63 131 248 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-blue-gray-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(96 125 139 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-brown-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(121 85 72 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-cyan-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 188 212 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-deep-orange-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 87 34 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-deep-purple-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(103 58 183 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-gray-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-green-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(14 159 110 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-indigo-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(104 117 245 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-light-blue-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(3 169 244 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-light-green-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(139 195 74 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-lime-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(205 220 57 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-orange-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 90 31 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-pink-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(231 70 148 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-purple-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(144 97 249 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-red-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(240 82 82 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-teal-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(6 148 162 / var(--tw-bg-opacity));
}

.peer:checked ~ .peer-checked\\:before\\:bg-yellow-500::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(194 120 3 / var(--tw-bg-opacity));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:top-1\\/2 {
  top: 50%;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[3\\.75\\] {
  line-height: 3.75;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[4\\.1\\] {
  line-height: 4.1;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[4\\.25\\] {
  line-height: 4.25;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-\\[4\\.875\\] {
  line-height: 4.875;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:leading-tight {
  line-height: 1.25;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-blue-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(14 159 110 / var(--tw-text-opacity));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(240 82 82 / var(--tw-text-opacity));
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:before\\:border-transparent::before {
  content: var(--tw-content);
  border-color: transparent;
}

.peer:placeholder-shown ~ .peer-placeholder-shown\\:after\\:border-transparent::after {
  content: var(--tw-content);
  border-color: transparent;
}

.peer:focus ~ .peer-focus\\:left-0 {
  left: 0px;
}

.peer:focus ~ .peer-focus\\:top-2 {
  top: 0.5rem;
}

.peer:focus ~ .peer-focus\\:-translate-y-4 {
  --tw-translate-y: -1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:-translate-y-6 {
  --tw-translate-y: -1.5rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:scale-75 {
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.peer:focus ~ .peer-focus\\:text-\\[11px\\] {
  font-size: 11px;
}

.peer:focus ~ .peer-focus\\:text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.peer:focus ~ .peer-focus\\:leading-tight {
  line-height: 1.25;
}

.peer:focus ~ .peer-focus\\:text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(255 193 7 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(63 131 248 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(28 100 242 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-blue-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-brown-500 {
  --tw-text-opacity: 1;
  color: rgb(121 85 72 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(0 188 212 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-deep-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 87 34 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-deep-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(103 58 183 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(14 159 110 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(104 117 245 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-light-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(3 169 244 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-light-green-500 {
  --tw-text-opacity: 1;
  color: rgb(139 195 74 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-lime-500 {
  --tw-text-opacity: 1;
  color: rgb(205 220 57 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(255 90 31 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-pink-500 {
  --tw-text-opacity: 1;
  color: rgb(231 70 148 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(144 97 249 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(240 82 82 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(6 148 162 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(194 120 3 / var(--tw-text-opacity));
}

.peer:focus ~ .peer-focus\\:before\\:border-l-2::before {
  content: var(--tw-content);
  border-left-width: 2px;
}

.peer:focus ~ .peer-focus\\:before\\:border-t-2::before {
  content: var(--tw-content);
  border-top-width: 2px;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-amber-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 193 7 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-black::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-blue-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(63 131 248 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-blue-gray-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(96 125 139 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-brown-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(121 85 72 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-cyan-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 188 212 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-deep-orange-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 87 34 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-deep-purple-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(103 58 183 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-gray-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(107 114 128 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(14 159 110 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-indigo-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(104 117 245 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-light-blue-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 169 244 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-light-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(139 195 74 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-lime-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(205 220 57 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-orange-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 90 31 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-pink-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(231 70 148 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-purple-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(144 97 249 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-red-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(240 82 82 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-teal-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(6 148 162 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-white::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:\\!border-yellow-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(194 120 3 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:before\\:border-green-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:before\\:border-red-500::before {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:scale-x-100::after {
  content: var(--tw-content);
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.peer:focus ~ .peer-focus\\:after\\:border-r-2::after {
  content: var(--tw-content);
  border-right-width: 2px;
}

.peer:focus ~ .peer-focus\\:after\\:border-t-2::after {
  content: var(--tw-content);
  border-top-width: 2px;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-amber-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 193 7 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-black::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(63 131 248 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-blue-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(96 125 139 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-brown-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(121 85 72 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-cyan-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 188 212 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-deep-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 87 34 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-deep-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(103 58 183 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(107 114 128 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(14 159 110 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-indigo-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(104 117 245 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-light-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(3 169 244 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-light-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(139 195 74 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-lime-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(205 220 57 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 90 31 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-pink-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(231 70 148 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(144 97 249 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-red-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(240 82 82 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-teal-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(6 148 162 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 255 255 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:\\!border-yellow-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1 !important;
  border-color: rgb(194 120 3 / var(--tw-border-opacity)) !important;
}

.peer:focus ~ .peer-focus\\:after\\:border-amber-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 193 7 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-black::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(63 131 248 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-blue-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(96 125 139 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-brown-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(121 85 72 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-cyan-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-deep-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 87 34 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-deep-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(103 58 183 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-gray-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-indigo-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(104 117 245 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-light-blue-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(3 169 244 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-light-green-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(139 195 74 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-lime-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(205 220 57 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-orange-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 90 31 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-pink-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(231 70 148 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-purple-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(144 97 249 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-red-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-teal-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(6 148 162 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-white::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.peer:focus ~ .peer-focus\\:after\\:border-yellow-500::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-color: rgb(194 120 3 / var(--tw-border-opacity));
}

.peer:disabled ~ .peer-disabled\\:text-blue-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(120 144 156 / var(--tw-text-opacity));
}

.peer:disabled ~ .peer-disabled\\:text-transparent {
  color: transparent;
}

.peer:disabled ~ .peer-disabled\\:before\\:border-transparent::before {
  content: var(--tw-content);
  border-color: transparent;
}

.peer:disabled ~ .peer-disabled\\:after\\:border-transparent::after {
  content: var(--tw-content);
  border-color: transparent;
}

.peer:disabled:placeholder-shown ~ .peer-disabled\\:peer-placeholder-shown\\:text-blue-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(96 125 139 / var(--tw-text-opacity));
}

:is([dir="rtl"] .rtl\\:after\\:right-1)::after {
  content: var(--tw-content);
  right: 0.25rem;
}

:is([dir="rtl"] .rtl\\:after\\:right-px)::after {
  content: var(--tw-content);
  right: 1px;
}

:is([dir="rtl"] .rtl\\:after\\:-translate-x-full)::after {
  content: var(--tw-content);
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

:is(.dark .dark\\:block) {
  display: block;
}

:is(.dark .dark\\:hidden) {
  display: none;
}

:is(.dark .dark\\:divide-gray-700) > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-divide-opacity));
}

:is(.dark .dark\\:border-none) {
  border-style: none;
}

:is(.dark .dark\\:border-cyan-400) {
  --tw-border-opacity: 1;
  border-color: rgb(38 198 218 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-cyan-500) {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-cyan-600) {
  --tw-border-opacity: 1;
  border-color: rgb(0 172 193 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-gray-500) {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-gray-600) {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-gray-700) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-gray-800) {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-gray-900) {
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-green-400) {
  --tw-border-opacity: 1;
  border-color: rgb(49 196 141 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-green-500) {
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-green-600) {
  --tw-border-opacity: 1;
  border-color: rgb(5 122 85 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-indigo-600) {
  --tw-border-opacity: 1;
  border-color: rgb(88 80 236 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-lime-600) {
  --tw-border-opacity: 1;
  border-color: rgb(192 202 51 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-pink-600) {
  --tw-border-opacity: 1;
  border-color: rgb(214 31 105 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-red-400) {
  --tw-border-opacity: 1;
  border-color: rgb(249 128 128 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-red-500) {
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-red-600) {
  --tw-border-opacity: 1;
  border-color: rgb(224 36 36 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-teal-600) {
  --tw-border-opacity: 1;
  border-color: rgb(4 116 129 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-white) {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-yellow-400) {
  --tw-border-opacity: 1;
  border-color: rgb(227 160 8 / var(--tw-border-opacity));
}

:is(.dark .dark\\:border-yellow-600) {
  --tw-border-opacity: 1;
  border-color: rgb(159 88 10 / var(--tw-border-opacity));
}

:is(.dark .dark\\:\\!bg-gray-700) {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity)) !important;
}

:is(.dark .dark\\:bg-black) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-blue-200) {
  --tw-bg-opacity: 1;
  background-color: rgb(195 221 253 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-blue-600) {
  --tw-bg-opacity: 1;
  background-color: rgb(28 100 242 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-cyan-100) {
  --tw-bg-opacity: 1;
  background-color: rgb(178 235 242 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-cyan-200) {
  --tw-bg-opacity: 1;
  background-color: rgb(128 222 234 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-cyan-600) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 172 193 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-cyan-900) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 96 100 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-gray-200) {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-gray-300) {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-gray-400) {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-gray-500) {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-gray-600) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-gray-700) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-gray-800) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-gray-800\\/30) {
  background-color: rgb(31 41 55 / 0.3);
}

:is(.dark .dark\\:bg-gray-800\\/50) {
  background-color: rgb(31 41 55 / 0.5);
}

:is(.dark .dark\\:bg-gray-900) {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-gray-900\\/80) {
  background-color: rgb(17 24 39 / 0.8);
}

:is(.dark .dark\\:bg-green-100) {
  --tw-bg-opacity: 1;
  background-color: rgb(222 247 236 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-green-200) {
  --tw-bg-opacity: 1;
  background-color: rgb(188 240 218 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-green-500) {
  --tw-bg-opacity: 1;
  background-color: rgb(14 159 110 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-green-600) {
  --tw-bg-opacity: 1;
  background-color: rgb(5 122 85 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-green-900) {
  --tw-bg-opacity: 1;
  background-color: rgb(1 71 55 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-indigo-200) {
  --tw-bg-opacity: 1;
  background-color: rgb(205 219 254 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-indigo-500) {
  --tw-bg-opacity: 1;
  background-color: rgb(104 117 245 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-indigo-600) {
  --tw-bg-opacity: 1;
  background-color: rgb(88 80 236 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-lime-200) {
  --tw-bg-opacity: 1;
  background-color: rgb(230 238 156 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-lime-600) {
  --tw-bg-opacity: 1;
  background-color: rgb(192 202 51 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-pink-200) {
  --tw-bg-opacity: 1;
  background-color: rgb(250 209 232 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-pink-600) {
  --tw-bg-opacity: 1;
  background-color: rgb(214 31 105 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-purple-200) {
  --tw-bg-opacity: 1;
  background-color: rgb(220 215 254 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-purple-500) {
  --tw-bg-opacity: 1;
  background-color: rgb(144 97 249 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-purple-600) {
  --tw-bg-opacity: 1;
  background-color: rgb(126 58 242 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-purple-900) {
  --tw-bg-opacity: 1;
  background-color: rgb(74 29 150 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-red-100) {
  --tw-bg-opacity: 1;
  background-color: rgb(253 232 232 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-red-200) {
  --tw-bg-opacity: 1;
  background-color: rgb(251 213 213 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-red-500) {
  --tw-bg-opacity: 1;
  background-color: rgb(240 82 82 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-red-600) {
  --tw-bg-opacity: 1;
  background-color: rgb(224 36 36 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-red-900) {
  --tw-bg-opacity: 1;
  background-color: rgb(119 29 29 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-teal-200) {
  --tw-bg-opacity: 1;
  background-color: rgb(175 236 239 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-teal-600) {
  --tw-bg-opacity: 1;
  background-color: rgb(4 116 129 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-transparent) {
  background-color: transparent;
}

:is(.dark .dark\\:bg-yellow-100) {
  --tw-bg-opacity: 1;
  background-color: rgb(253 246 178 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-yellow-200) {
  --tw-bg-opacity: 1;
  background-color: rgb(252 233 106 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-yellow-600) {
  --tw-bg-opacity: 1;
  background-color: rgb(159 88 10 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-yellow-900) {
  --tw-bg-opacity: 1;
  background-color: rgb(99 49 18 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:bg-opacity-80) {
  --tw-bg-opacity: 0.8;
}

:is(.dark .dark\\:fill-gray-300) {
  fill: #D1D5DB;
}

:is(.dark .dark\\:text-blue-500) {
  --tw-text-opacity: 1;
  color: rgb(63 131 248 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-blue-600) {
  --tw-text-opacity: 1;
  color: rgb(28 100 242 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-blue-800) {
  --tw-text-opacity: 1;
  color: rgb(30 66 159 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-blue-900) {
  --tw-text-opacity: 1;
  color: rgb(35 56 118 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-cyan-100) {
  --tw-text-opacity: 1;
  color: rgb(178 235 242 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-cyan-300) {
  --tw-text-opacity: 1;
  color: rgb(77 208 225 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-cyan-500) {
  --tw-text-opacity: 1;
  color: rgb(0 188 212 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-cyan-600) {
  --tw-text-opacity: 1;
  color: rgb(0 172 193 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-cyan-800) {
  --tw-text-opacity: 1;
  color: rgb(0 131 143 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-cyan-900) {
  --tw-text-opacity: 1;
  color: rgb(0 96 100 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-gray-100) {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-gray-200) {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-gray-300) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-gray-400) {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-gray-500) {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-gray-600) {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-gray-800) {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-gray-900) {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-green-400) {
  --tw-text-opacity: 1;
  color: rgb(49 196 141 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-green-500) {
  --tw-text-opacity: 1;
  color: rgb(14 159 110 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-green-600) {
  --tw-text-opacity: 1;
  color: rgb(5 122 85 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-green-800) {
  --tw-text-opacity: 1;
  color: rgb(3 84 63 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-green-900) {
  --tw-text-opacity: 1;
  color: rgb(1 71 55 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-indigo-600) {
  --tw-text-opacity: 1;
  color: rgb(88 80 236 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-indigo-800) {
  --tw-text-opacity: 1;
  color: rgb(66 56 157 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-indigo-900) {
  --tw-text-opacity: 1;
  color: rgb(54 47 120 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-lime-600) {
  --tw-text-opacity: 1;
  color: rgb(192 202 51 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-lime-800) {
  --tw-text-opacity: 1;
  color: rgb(158 157 36 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-lime-900) {
  --tw-text-opacity: 1;
  color: rgb(130 119 23 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-pink-600) {
  --tw-text-opacity: 1;
  color: rgb(214 31 105 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-pink-800) {
  --tw-text-opacity: 1;
  color: rgb(153 21 75 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-pink-900) {
  --tw-text-opacity: 1;
  color: rgb(117 26 61 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-purple-600) {
  --tw-text-opacity: 1;
  color: rgb(126 58 242 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-purple-800) {
  --tw-text-opacity: 1;
  color: rgb(85 33 181 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-purple-900) {
  --tw-text-opacity: 1;
  color: rgb(74 29 150 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-red-400) {
  --tw-text-opacity: 1;
  color: rgb(249 128 128 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-red-500) {
  --tw-text-opacity: 1;
  color: rgb(240 82 82 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-red-600) {
  --tw-text-opacity: 1;
  color: rgb(224 36 36 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-red-800) {
  --tw-text-opacity: 1;
  color: rgb(155 28 28 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-red-900) {
  --tw-text-opacity: 1;
  color: rgb(119 29 29 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-teal-600) {
  --tw-text-opacity: 1;
  color: rgb(4 116 129 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-teal-800) {
  --tw-text-opacity: 1;
  color: rgb(5 80 92 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-teal-900) {
  --tw-text-opacity: 1;
  color: rgb(1 68 81 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-white) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-yellow-600) {
  --tw-text-opacity: 1;
  color: rgb(159 88 10 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-yellow-800) {
  --tw-text-opacity: 1;
  color: rgb(114 59 19 / var(--tw-text-opacity));
}

:is(.dark .dark\\:text-yellow-900) {
  --tw-text-opacity: 1;
  color: rgb(99 49 18 / var(--tw-text-opacity));
}

:is(.dark .dark\\:placeholder-gray-400)::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity));
}

:is(.dark .dark\\:mix-blend-color) {
  mix-blend-mode: color;
}

:is(.dark .dark\\:shadow-sm-light) {
  --tw-shadow: 0 2px 5px 0px rgba(255, 255, 255, 0.08);
  --tw-shadow-colored: 0 2px 5px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

:is(.dark .dark\\:ring-cyan-800) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 131 143 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:ring-gray-400) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:ring-gray-500) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:ring-gray-800) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(31 41 55 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:ring-gray-900) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(17 24 39 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:ring-green-500) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 159 110 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:ring-pink-500) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(231 70 148 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:ring-purple-600) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 58 242 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:ring-red-700) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(200 30 30 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:ring-yellow-500) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(194 120 3 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:ring-offset-blue-700) {
  --tw-ring-offset-color: #1A56DB;
}

:is(.dark .dark\\:ring-offset-cyan-600) {
  --tw-ring-offset-color: #00acc1;
}

:is(.dark .dark\\:ring-offset-gray-800) {
  --tw-ring-offset-color: #1F2937;
}

:is(.dark .dark\\:ring-offset-gray-900) {
  --tw-ring-offset-color: #111827;
}

:is(.dark .dark\\:ring-offset-green-600) {
  --tw-ring-offset-color: #057A55;
}

:is(.dark .dark\\:ring-offset-green-800) {
  --tw-ring-offset-color: #03543F;
}

:is(.dark .dark\\:ring-offset-indigo-700) {
  --tw-ring-offset-color: #5145CD;
}

:is(.dark .dark\\:ring-offset-lime-700) {
  --tw-ring-offset-color: #afb42b;
}

:is(.dark .dark\\:ring-offset-pink-600) {
  --tw-ring-offset-color: #D61F69;
}

:is(.dark .dark\\:ring-offset-purple-600) {
  --tw-ring-offset-color: #7E3AF2;
}

:is(.dark .dark\\:ring-offset-red-600) {
  --tw-ring-offset-color: #E02424;
}

:is(.dark .dark\\:ring-offset-red-900) {
  --tw-ring-offset-color: #771D1D;
}

:is(.dark .dark\\:ring-offset-teal-600) {
  --tw-ring-offset-color: #047481;
}

:is(.dark .dark\\:ring-offset-yellow-400) {
  --tw-ring-offset-color: #E3A008;
}

:is(.dark .odd\\:dark\\:bg-gray-800):nth-child(odd) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}

:is(.dark .even\\:dark\\:bg-gray-700):nth-child(even) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:hover\\:bg-blue-300:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(164 202 254 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:hover\\:bg-blue-700:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(26 86 219 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:hover\\:bg-cyan-300:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(77 208 225 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:hover\\:bg-cyan-700:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 151 167 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:hover\\:bg-gray-300:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:hover\\:bg-gray-600:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:hover\\:bg-gray-700:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:hover\\:bg-gray-800:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:hover\\:bg-green-300:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(132 225 188 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:hover\\:bg-indigo-300:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(180 198 252 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:hover\\:bg-lime-300:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(220 231 117 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:hover\\:bg-pink-300:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(248 180 217 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:hover\\:bg-purple-300:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(202 191 253 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:hover\\:bg-red-300:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(248 180 180 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:hover\\:bg-teal-300:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(126 220 226 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:hover\\:bg-yellow-300:hover) {
  --tw-bg-opacity: 1;
  background-color: rgb(250 202 21 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:hover\\:text-gray-300:hover) {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}

:is(.dark .dark\\:hover\\:text-white:hover) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

:is(.dark .dark\\:focus\\:border-blue-500:focus) {
  --tw-border-opacity: 1;
  border-color: rgb(63 131 248 / var(--tw-border-opacity));
}

:is(.dark .dark\\:focus\\:border-cyan-500:focus) {
  --tw-border-opacity: 1;
  border-color: rgb(0 188 212 / var(--tw-border-opacity));
}

:is(.dark .dark\\:focus\\:border-green-500:focus) {
  --tw-border-opacity: 1;
  border-color: rgb(14 159 110 / var(--tw-border-opacity));
}

:is(.dark .dark\\:focus\\:border-red-500:focus) {
  --tw-border-opacity: 1;
  border-color: rgb(240 82 82 / var(--tw-border-opacity));
}

:is(.dark .dark\\:focus\\:border-yellow-500:focus) {
  --tw-border-opacity: 1;
  border-color: rgb(194 120 3 / var(--tw-border-opacity));
}

:is(.dark .dark\\:focus\\:bg-cyan-600:focus) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 172 193 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:focus\\:bg-gray-600:focus) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:focus\\:text-white:focus) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

:is(.dark .dark\\:focus\\:ring-blue-700:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(26 86 219 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-blue-800:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 66 159 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-cyan-500:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 188 212 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-cyan-600:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 172 193 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-cyan-700:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 151 167 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-cyan-800:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 131 143 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-gray-500:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(107 114 128 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-gray-600:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(75 85 99 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-gray-700:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(55 65 81 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-gray-800:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(31 41 55 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-gray-900:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(17 24 39 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-green-500:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 159 110 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-green-600:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 122 85 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-green-700:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(4 108 78 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-green-800:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(3 84 63 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-indigo-700:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(81 69 205 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-lime-700:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(175 180 43 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-lime-800:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(158 157 36 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-pink-600:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(214 31 105 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-pink-700:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 18 93 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-pink-800:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(153 21 75 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-purple-600:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(126 58 242 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-purple-800:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(85 33 181 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-purple-900:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(74 29 150 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-red-400:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(249 128 128 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-red-500:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(240 82 82 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-red-600:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 36 36 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-red-700:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(200 30 30 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-red-800:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(155 28 28 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-red-900:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(119 29 29 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-teal-600:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(4 116 129 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-teal-700:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(3 102 114 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-teal-800:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(5 80 92 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-yellow-400:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(227 160 8 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-yellow-500:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(194 120 3 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-yellow-700:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(142 75 16 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:focus\\:ring-yellow-900:focus) {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 49 18 / var(--tw-ring-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:border-cyan-700:hover:enabled) {
  --tw-border-opacity: 1;
  border-color: rgb(0 151 167 / var(--tw-border-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:border-gray-700:hover:enabled) {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:border-green-700:hover:enabled) {
  --tw-border-opacity: 1;
  border-color: rgb(4 108 78 / var(--tw-border-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:border-indigo-700:hover:enabled) {
  --tw-border-opacity: 1;
  border-color: rgb(81 69 205 / var(--tw-border-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:border-lime-700:hover:enabled) {
  --tw-border-opacity: 1;
  border-color: rgb(175 180 43 / var(--tw-border-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:border-pink-700:hover:enabled) {
  --tw-border-opacity: 1;
  border-color: rgb(191 18 93 / var(--tw-border-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:border-red-700:hover:enabled) {
  --tw-border-opacity: 1;
  border-color: rgb(200 30 30 / var(--tw-border-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:border-teal-700:hover:enabled) {
  --tw-border-opacity: 1;
  border-color: rgb(3 102 114 / var(--tw-border-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:border-yellow-700:hover:enabled) {
  --tw-border-opacity: 1;
  border-color: rgb(142 75 16 / var(--tw-border-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:bg-cyan-700:hover:enabled) {
  --tw-bg-opacity: 1;
  background-color: rgb(0 151 167 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:bg-gray-700:hover:enabled) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:bg-green-700:hover:enabled) {
  --tw-bg-opacity: 1;
  background-color: rgb(4 108 78 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:bg-indigo-700:hover:enabled) {
  --tw-bg-opacity: 1;
  background-color: rgb(81 69 205 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:bg-lime-700:hover:enabled) {
  --tw-bg-opacity: 1;
  background-color: rgb(175 180 43 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:bg-pink-700:hover:enabled) {
  --tw-bg-opacity: 1;
  background-color: rgb(191 18 93 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:bg-purple-700:hover:enabled) {
  --tw-bg-opacity: 1;
  background-color: rgb(108 43 217 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:bg-red-700:hover:enabled) {
  --tw-bg-opacity: 1;
  background-color: rgb(200 30 30 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:bg-teal-700:hover:enabled) {
  --tw-bg-opacity: 1;
  background-color: rgb(3 102 114 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:bg-yellow-700:hover:enabled) {
  --tw-bg-opacity: 1;
  background-color: rgb(142 75 16 / var(--tw-bg-opacity));
}

:is(.dark .enabled\\:dark\\:hover\\:bg-gray-700:hover):enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}

:is(.dark .dark\\:enabled\\:hover\\:text-white:hover:enabled) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

:is(.dark .enabled\\:dark\\:hover\\:text-white:hover):enabled {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

:is(.dark .disabled\\:dark\\:text-gray-500):disabled {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}

:is(.dark .group:hover .dark\\:group-hover\\:bg-blue-300) {
  --tw-bg-opacity: 1;
  background-color: rgb(164 202 254 / var(--tw-bg-opacity));
}

:is(.dark .group:hover .dark\\:group-hover\\:bg-cyan-300) {
  --tw-bg-opacity: 1;
  background-color: rgb(77 208 225 / var(--tw-bg-opacity));
}

:is(.dark .group:hover .dark\\:group-hover\\:bg-gray-500) {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}

:is(.dark .group:hover .dark\\:group-hover\\:bg-gray-600) {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}

:is(.dark .group:hover .dark\\:group-hover\\:bg-gray-700) {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}

:is(.dark .group:hover .dark\\:group-hover\\:bg-gray-800\\/60) {
  background-color: rgb(31 41 55 / 0.6);
}

:is(.dark .group:hover .dark\\:group-hover\\:bg-green-300) {
  --tw-bg-opacity: 1;
  background-color: rgb(132 225 188 / var(--tw-bg-opacity));
}

:is(.dark .group:hover .dark\\:group-hover\\:bg-indigo-300) {
  --tw-bg-opacity: 1;
  background-color: rgb(180 198 252 / var(--tw-bg-opacity));
}

:is(.dark .group:hover .dark\\:group-hover\\:bg-lime-300) {
  --tw-bg-opacity: 1;
  background-color: rgb(220 231 117 / var(--tw-bg-opacity));
}

:is(.dark .group:hover .dark\\:group-hover\\:bg-pink-300) {
  --tw-bg-opacity: 1;
  background-color: rgb(248 180 217 / var(--tw-bg-opacity));
}

:is(.dark .group:hover .dark\\:group-hover\\:bg-purple-300) {
  --tw-bg-opacity: 1;
  background-color: rgb(202 191 253 / var(--tw-bg-opacity));
}

:is(.dark .group:hover .dark\\:group-hover\\:bg-red-300) {
  --tw-bg-opacity: 1;
  background-color: rgb(248 180 180 / var(--tw-bg-opacity));
}

:is(.dark .group:hover .dark\\:group-hover\\:bg-teal-300) {
  --tw-bg-opacity: 1;
  background-color: rgb(126 220 226 / var(--tw-bg-opacity));
}

:is(.dark .group:hover .dark\\:group-hover\\:bg-yellow-300) {
  --tw-bg-opacity: 1;
  background-color: rgb(250 202 21 / var(--tw-bg-opacity));
}

:is(.dark .group:hover .dark\\:group-hover\\:text-white) {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

:is(.dark .group:focus .dark\\:group-focus\\:ring-gray-800\\/70) {
  --tw-ring-color: rgb(31 41 55 / 0.7);
}

.peer:focus ~ :is(.dark .peer-focus\\:dark\\:text-blue-500) {
  --tw-text-opacity: 1;
  color: rgb(63 131 248 / var(--tw-text-opacity));
}

@media (min-width: 320px) and (max-width: 767px) {

  .sm\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:mb-0 {
    margin-bottom: 0px;
  }

  .sm\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .sm\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-10 {
    height: 2.5rem;
  }

  .sm\\:h-6 {
    height: 1.5rem;
  }

  .sm\\:h-7 {
    height: 1.75rem;
  }

  .sm\\:h-\\[150px\\] {
    height: 150px;
  }

  .sm\\:w-10 {
    width: 2.5rem;
  }

  .sm\\:w-6 {
    width: 1.5rem;
  }

  .sm\\:w-\\[150px\\] {
    width: 150px;
  }

  .sm\\:w-\\[180px\\] {
    width: 180px;
  }

  .sm\\:w-\\[200px\\] {
    width: 200px;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:flex-col-reverse {
    flex-direction: column-reverse;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:justify-center {
    justify-content: center;
  }

  .sm\\:p-2 {
    padding: 0.5rem;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:pr-8 {
    padding-right: 2rem;
  }

  .sm\\:text-center {
    text-align: center;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

@media (min-width: 768px) {

  .md\\:inset-0 {
    inset: 0px;
  }

  .md\\:-bottom-\\[60px\\] {
    bottom: -60px;
  }

  .md\\:left-8 {
    left: 2rem;
  }

  .md\\:order-3 {
    order: 3;
  }

  .md\\:mx-16 {
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .md\\:mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .md\\:mx-8 {
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .md\\:my-10 {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .md\\:my-12 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .md\\:mb-7 {
    margin-bottom: 1.75rem;
  }

  .md\\:mr-6 {
    margin-right: 1.5rem;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-\\[120px\\] {
    height: 120px;
  }

  .md\\:h-\\[180px\\] {
    height: 180px;
  }

  .md\\:h-\\[200px\\] {
    height: 200px;
  }

  .md\\:h-\\[20rem\\] {
    height: 20rem;
  }

  .md\\:h-auto {
    height: auto;
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:w-2\\/3 {
    width: 66.666667%;
  }

  .md\\:w-3\\/4 {
    width: 75%;
  }

  .md\\:w-3\\/5 {
    width: 60%;
  }

  .md\\:w-48 {
    width: 12rem;
  }

  .md\\:w-5\\/6 {
    width: 83.333333%;
  }

  .md\\:w-\\[120px\\] {
    width: 120px;
  }

  .md\\:w-\\[13rem\\] {
    width: 13rem;
  }

  .md\\:w-\\[15rem\\] {
    width: 15rem;
  }

  .md\\:w-\\[18rem\\] {
    width: 18rem;
  }

  .md\\:w-\\[30rem\\] {
    width: 30rem;
  }

  .md\\:w-\\[400px\\] {
    width: 400px;
  }

  .md\\:w-\\[40rem\\] {
    width: 40rem;
  }

  .md\\:w-\\[50rem\\] {
    width: 50rem;
  }

  .md\\:w-\\[600px\\] {
    width: 600px;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:min-w-\\[60\\%\\] {
    min-width: 60%;
  }

  .md\\:min-w-\\[66\\.666667\\%\\] {
    min-width: 66.666667%;
  }

  .md\\:min-w-\\[75\\%\\] {
    min-width: 75%;
  }

  .md\\:min-w-\\[83\\.333333\\%\\] {
    min-width: 83.333333%;
  }

  .md\\:max-w-\\[60\\%\\] {
    max-width: 60%;
  }

  .md\\:max-w-\\[66\\.666667\\%\\] {
    max-width: 66.666667%;
  }

  .md\\:max-w-\\[75\\%\\] {
    max-width: 75%;
  }

  .md\\:max-w-\\[83\\.333333\\%\\] {
    max-width: 83.333333%;
  }

  .md\\:max-w-xl {
    max-width: 36rem;
  }

  .md\\:grow {
    flex-grow: 1;
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col-reverse {
    flex-direction: column-reverse;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-2 {
    gap: 0.5rem;
  }

  .md\\:gap-3 {
    gap: 0.75rem;
  }

  .md\\:gap-5 {
    gap: 1.25rem;
  }

  .md\\:gap-6 {
    gap: 1.5rem;
  }

  .md\\:gap-\\[2rem\\] {
    gap: 2rem;
  }

  .md\\:space-x-8 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(2rem * var(--tw-space-x-reverse));
    margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:rounded-none {
    border-radius: 0px;
  }

  .md\\:rounded-l-lg {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }

  .md\\:border-0 {
    border-width: 0px;
  }

  .md\\:bg-transparent {
    background-color: transparent;
  }

  .md\\:p-0 {
    padding: 0px;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .md\\:px-\\[10px\\] {
    padding-left: 10px;
    padding-right: 10px;
  }

  .md\\:pb-\\[20\\] {
    padding-bottom: 20;
  }

  .md\\:pt-\\[0rem\\] {
    padding-top: 0rem;
  }

  .md\\:pt-\\[10rem\\] {
    padding-top: 10rem;
  }

  .md\\:pt-\\[2rem\\] {
    padding-top: 2rem;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-\\[1\\.6rem\\] {
    font-size: 1.6rem;
  }

  .md\\:text-\\[14px\\] {
    font-size: 14px;
  }

  .md\\:text-\\[2\\.3rem\\] {
    font-size: 2.3rem;
  }

  .md\\:text-\\[2\\.5rem\\] {
    font-size: 2.5rem;
  }

  .md\\:text-\\[2\\.7rem\\] {
    font-size: 2.7rem;
  }

  .md\\:text-\\[2rem\\] {
    font-size: 2rem;
  }

  .md\\:text-\\[3rem\\] {
    font-size: 3rem;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:font-medium {
    font-weight: 500;
  }

  .md\\:leading-none {
    line-height: 1;
  }

  .md\\:text-cyan-700 {
    --tw-text-opacity: 1;
    color: rgb(0 151 167 / var(--tw-text-opacity));
  }

  .md\\:hover\\:bg-transparent:hover {
    background-color: transparent;
  }

  .md\\:hover\\:text-cyan-700:hover {
    --tw-text-opacity: 1;
    color: rgb(0 151 167 / var(--tw-text-opacity));
  }

  :is(.dark .md\\:dark\\:hover\\:bg-transparent:hover) {
    background-color: transparent;
  }

  :is(.dark .md\\:dark\\:hover\\:text-white:hover) {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }
}

@media (min-width: 1024px) {

  .lg\\:order-2 {
    order: 2;
  }

  .lg\\:m-0 {
    margin: 0px;
  }

  .lg\\:my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .lg\\:-ml-7 {
    margin-left: -1.75rem;
  }

  .lg\\:-mt-\\[3\\.2rem\\] {
    margin-top: -3.2rem;
  }

  .lg\\:mb-1 {
    margin-bottom: 0.25rem;
  }

  .lg\\:mb-7 {
    margin-bottom: 1.75rem;
  }

  .lg\\:ml-\\[85px\\] {
    margin-left: 85px;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:mt-1 {
    margin-top: 0.25rem;
  }

  .lg\\:mt-4 {
    margin-top: 1rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-96 {
    height: 24rem;
  }

  .lg\\:h-\\[200px\\] {
    height: 200px;
  }

  .lg\\:h-\\[250px\\] {
    height: 250px;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:w-2\\/4 {
    width: 50%;
  }

  .lg\\:w-2\\/5 {
    width: 40%;
  }

  .lg\\:w-3\\/4 {
    width: 75%;
  }

  .lg\\:w-3\\/5 {
    width: 60%;
  }

  .lg\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .lg\\:w-\\[100rem\\] {
    width: 100rem;
  }

  .lg\\:w-\\[10rem\\] {
    width: 10rem;
  }

  .lg\\:w-\\[15rem\\] {
    width: 15rem;
  }

  .lg\\:w-\\[18rem\\] {
    width: 18rem;
  }

  .lg\\:w-\\[200px\\] {
    width: 200px;
  }

  .lg\\:w-\\[20rem\\] {
    width: 20rem;
  }

  .lg\\:w-\\[230px\\] {
    width: 230px;
  }

  .lg\\:w-\\[23rem\\] {
    width: 23rem;
  }

  .lg\\:w-\\[250px\\] {
    width: 250px;
  }

  .lg\\:w-\\[500px\\] {
    width: 500px;
  }

  .lg\\:w-\\[50rem\\] {
    width: 50rem;
  }

  .lg\\:w-\\[60rem\\] {
    width: 60rem;
  }

  .lg\\:w-\\[70rem\\] {
    width: 70rem;
  }

  .lg\\:w-\\[80rem\\] {
    width: 80rem;
  }

  .lg\\:w-\\[8rem\\] {
    width: 8rem;
  }

  .lg\\:w-full {
    width: 100%;
  }

  .lg\\:min-w-\\[40\\%\\] {
    min-width: 40%;
  }

  .lg\\:min-w-\\[50\\%\\] {
    min-width: 50%;
  }

  .lg\\:min-w-\\[60\\%\\] {
    min-width: 60%;
  }

  .lg\\:min-w-\\[75\\%\\] {
    min-width: 75%;
  }

  .lg\\:max-w-\\[40\\%\\] {
    max-width: 40%;
  }

  .lg\\:max-w-\\[50\\%\\] {
    max-width: 50%;
  }

  .lg\\:max-w-\\[60\\%\\] {
    max-width: 60%;
  }

  .lg\\:max-w-\\[75\\%\\] {
    max-width: 75%;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-end {
    align-items: flex-end;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:justify-center {
    justify-content: center;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:gap-\\[0rem\\] {
    gap: 0rem;
  }

  .lg\\:gap-\\[3rem\\] {
    gap: 3rem;
  }

  .lg\\:gap-\\[5rem\\] {
    gap: 5rem;
  }

  .lg\\:gap-y-4 {
    row-gap: 1rem;
  }

  .lg\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .lg\\:px-\\[15px\\] {
    padding-left: 15px;
    padding-right: 15px;
  }

  .lg\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .lg\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .lg\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .lg\\:pb-20 {
    padding-bottom: 5rem;
  }

  .lg\\:pt-0 {
    padding-top: 0px;
  }

  .lg\\:pt-5 {
    padding-top: 1.25rem;
  }

  .lg\\:pt-\\[10rem\\] {
    padding-top: 10rem;
  }

  .lg\\:pt-\\[7rem\\] {
    padding-top: 7rem;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:text-right {
    text-align: right;
  }

  .lg\\:text-start {
    text-align: start;
  }

  .lg\\:text-end {
    text-align: end;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:text-\\[1\\.2rem\\] {
    font-size: 1.2rem;
  }

  .lg\\:text-\\[1\\.3rem\\] {
    font-size: 1.3rem;
  }

  .lg\\:text-\\[1\\.5rem\\] {
    font-size: 1.5rem;
  }

  .lg\\:text-\\[1rem\\] {
    font-size: 1rem;
  }

  .lg\\:text-\\[2\\.3rem\\] {
    font-size: 2.3rem;
  }

  .lg\\:text-\\[2\\.4rem\\] {
    font-size: 2.4rem;
  }

  .lg\\:text-\\[2\\.8rem\\] {
    font-size: 2.8rem;
  }

  .lg\\:text-\\[2rem\\] {
    font-size: 2rem;
  }

  .lg\\:text-\\[3\\.4rem\\] {
    font-size: 3.4rem;
  }

  .lg\\:text-\\[3\\.5rem\\] {
    font-size: 3.5rem;
  }

  .lg\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .lg\\:font-semibold {
    font-weight: 600;
  }

  .lg\\:leading-none {
    line-height: 1;
  }
}

@media (min-width: 1280px) {

  .xl\\:-ml-\\[190px\\] {
    margin-left: -190px;
  }

  .xl\\:h-\\[22rem\\] {
    height: 22rem;
  }

  .xl\\:h-full {
    height: 100%;
  }

  .xl\\:min-h-screen {
    min-height: 100vh;
  }

  .xl\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .xl\\:w-\\[100rem\\] {
    width: 100rem;
  }

  .xl\\:w-\\[13rem\\] {
    width: 13rem;
  }

  .xl\\:w-\\[23rem\\] {
    width: 23rem;
  }

  .xl\\:w-\\[25rem\\] {
    width: 25rem;
  }

  .xl\\:w-\\[50rem\\] {
    width: 50rem;
  }

  .xl\\:w-\\[70rem\\] {
    width: 70rem;
  }

  .xl\\:w-\\[7rem\\] {
    width: 7rem;
  }

  .xl\\:w-\\[80rem\\] {
    width: 80rem;
  }

  .xl\\:w-full {
    width: 100%;
  }

  .xl\\:items-end {
    align-items: flex-end;
  }

  .xl\\:justify-start {
    justify-content: flex-start;
  }

  .xl\\:justify-end {
    justify-content: flex-end;
  }

  .xl\\:gap-\\[18rem\\] {
    gap: 18rem;
  }

  .xl\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .xl\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .xl\\:px-\\[4rem\\] {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .xl\\:px-\\[7\\.5rem\\] {
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .xl\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .xl\\:pt-10 {
    padding-top: 2.5rem;
  }

  .xl\\:text-left {
    text-align: left;
  }

  .xl\\:text-end {
    text-align: end;
  }

  .xl\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .xl\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .xl\\:text-\\[1\\.3rem\\] {
    font-size: 1.3rem;
  }

  .xl\\:text-\\[1\\.5rem\\] {
    font-size: 1.5rem;
  }

  .xl\\:text-\\[1rem\\] {
    font-size: 1rem;
  }

  .xl\\:text-\\[2\\.5rem\\] {
    font-size: 2.5rem;
  }

  .xl\\:text-\\[2\\.8rem\\] {
    font-size: 2.8rem;
  }

  .xl\\:text-\\[2rem\\] {
    font-size: 2rem;
  }

  .xl\\:text-\\[3\\.2rem\\] {
    font-size: 3.2rem;
  }

  .xl\\:text-\\[3\\.5rem\\] {
    font-size: 3.5rem;
  }

  .xl\\:text-\\[3\\.7rem\\] {
    font-size: 3.7rem;
  }

  .xl\\:text-\\[3rem\\] {
    font-size: 3rem;
  }
}

@media (min-width: 1536px) {

  .\\32xl\\:m-auto {
    margin: auto;
  }

  .\\32xl\\:-ml-\\[280px\\] {
    margin-left: -280px;
  }

  .\\32xl\\:h-\\[24rem\\] {
    height: 24rem;
  }

  .\\32xl\\:h-full {
    height: 100%;
  }

  .\\32xl\\:min-h-screen {
    min-height: 100vh;
  }

  .\\32xl\\:w-1\\/3 {
    width: 33.333333%;
  }

  .\\32xl\\:w-1\\/4 {
    width: 25%;
  }

  .\\32xl\\:w-2\\/5 {
    width: 40%;
  }

  .\\32xl\\:w-3\\/4 {
    width: 75%;
  }

  .\\32xl\\:w-3\\/5 {
    width: 60%;
  }

  .\\32xl\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .\\32xl\\:w-\\[30rem\\] {
    width: 30rem;
  }

  .\\32xl\\:w-\\[80rem\\] {
    width: 80rem;
  }

  .\\32xl\\:min-w-\\[25\\%\\] {
    min-width: 25%;
  }

  .\\32xl\\:min-w-\\[33\\.333333\\%\\] {
    min-width: 33.333333%;
  }

  .\\32xl\\:min-w-\\[40\\%\\] {
    min-width: 40%;
  }

  .\\32xl\\:min-w-\\[60\\%\\] {
    min-width: 60%;
  }

  .\\32xl\\:min-w-\\[75\\%\\] {
    min-width: 75%;
  }

  .\\32xl\\:max-w-\\[25\\%\\] {
    max-width: 25%;
  }

  .\\32xl\\:max-w-\\[33\\.333333\\%\\] {
    max-width: 33.333333%;
  }

  .\\32xl\\:max-w-\\[40\\%\\] {
    max-width: 40%;
  }

  .\\32xl\\:max-w-\\[60\\%\\] {
    max-width: 60%;
  }

  .\\32xl\\:max-w-\\[75\\%\\] {
    max-width: 75%;
  }

  .\\32xl\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .\\32xl\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .\\32xl\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .\\32xl\\:text-7xl {
    font-size: 4.5rem;
    line-height: 1;
  }

  .\\32xl\\:text-\\[3rem\\] {
    font-size: 3rem;
  }

  .\\32xl\\:text-\\[4rem\\] {
    font-size: 4rem;
  }
}

@media (min-width: 2024px) and (max-width: 2560px) {

  .\\33xl\\:mb-4 {
    margin-bottom: 1rem;
  }

  .\\33xl\\:ml-\\[25px\\] {
    margin-left: 25px;
  }

  .\\33xl\\:items-center {
    align-items: center;
  }
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:relative::-moz-range-thumb {
  position: relative;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:z-20::-moz-range-thumb {
  z-index: 20;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:-mt-1::-moz-range-thumb {
  margin-top: -0.25rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:-mt-\\[3px\\]::-moz-range-thumb {
  margin-top: -3px;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:h-2\\.5::-moz-range-thumb {
  height: 0.625rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:h-3\\.5::-moz-range-thumb {
  height: 0.875rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:h-5::-moz-range-thumb {
  height: 1.25rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:w-2\\.5::-moz-range-thumb {
  width: 0.625rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:w-3\\.5::-moz-range-thumb {
  width: 0.875rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:w-5::-moz-range-thumb {
  width: 1.25rem;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:appearance-none::-moz-range-thumb {
  appearance: none;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:rounded-full::-moz-range-thumb {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:border-0::-moz-range-thumb {
  border-width: 0px;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:bg-white::-moz-range-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:ring-2::-moz-range-thumb {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:ring-current::-moz-range-thumb {
  --tw-ring-color: currentColor;
}

.\\[\\&\\:\\:-moz-range-thumb\\]\\:\\[-webkit-appearance\\:none\\]::-moz-range-thumb {
  -webkit-appearance: none;
}

.\\[\\&\\:\\:-moz-range-track\\]\\:h-full::-moz-range-track {
  height: 100%;
}

.\\[\\&\\:\\:-moz-range-track\\]\\:rounded-full::-moz-range-track {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-moz-range-track\\]\\:bg-blue-gray-100::-moz-range-track {
  --tw-bg-opacity: 1;
  background-color: rgb(207 216 220 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:\\!hidden::-webkit-scrollbar {
  display: none !important;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:\\!h-0::-webkit-scrollbar {
  height: 0px !important;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:\\!w-0::-webkit-scrollbar {
  width: 0px !important;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:\\!bg-transparent::-webkit-scrollbar {
  background-color: transparent !important;
}

.\\[\\&\\:\\:-webkit-slider-runnable-track\\]\\:h-full::-webkit-slider-runnable-track {
  height: 100%;
}

.\\[\\&\\:\\:-webkit-slider-runnable-track\\]\\:rounded-full::-webkit-slider-runnable-track {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-webkit-slider-runnable-track\\]\\:bg-blue-gray-100::-webkit-slider-runnable-track {
  --tw-bg-opacity: 1;
  background-color: rgb(207 216 220 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:relative::-webkit-slider-thumb {
  position: relative;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:z-20::-webkit-slider-thumb {
  z-index: 20;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:-mt-1::-webkit-slider-thumb {
  margin-top: -0.25rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:-mt-\\[3px\\]::-webkit-slider-thumb {
  margin-top: -3px;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-2\\.5::-webkit-slider-thumb {
  height: 0.625rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-3\\.5::-webkit-slider-thumb {
  height: 0.875rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-5::-webkit-slider-thumb {
  height: 1.25rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-2\\.5::-webkit-slider-thumb {
  width: 0.625rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-3\\.5::-webkit-slider-thumb {
  width: 0.875rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-5::-webkit-slider-thumb {
  width: 1.25rem;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:appearance-none::-webkit-slider-thumb {
  appearance: none;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:rounded-full::-webkit-slider-thumb {
  border-radius: 9999px;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:border-0::-webkit-slider-thumb {
  border-width: 0px;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:bg-white::-webkit-slider-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:ring-2::-webkit-slider-thumb {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:ring-current::-webkit-slider-thumb {
  --tw-ring-color: currentColor;
}

.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:\\[-webkit-appearance\\:none\\]::-webkit-slider-thumb {
  -webkit-appearance: none;
}

.\\[\\&\\>\\*\\]\\:pointer-events-none>* {
  pointer-events: none;
}

.\\[\\&\\>\\*\\]\\:cursor-grab>* {
  cursor: grab;
}

.\\[\\&\\>\\*\\]\\:first\\:rounded-t-lg:first-child>* {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.\\[\\&\\>\\*\\]\\:last\\:rounded-b-lg:last-child>* {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.\\[\\&\\>\\*\\]\\:last\\:border-b-0:last-child>* {
  border-bottom-width: 0px;
}

.\\[\\&_\\*\\]\\:cursor-pointer * {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,kBAAc;EAAd,UAAc;EAAd,WAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,WAAc;EAAd,mBAAc;EAAd;AAAc;;AAAd;EAAA,WAAc;EAAd,mBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,UAAc;EAAd,WAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA,qBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,gBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,sBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,mBAAc;EAAd,sBAAc;AAAA;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,iFAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,yDAAc;EAAd,yCAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd,qBAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,wCAAc;EAAd,sBAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,wBAAc;EAAd,sBAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,gBAAc;EAAd,UAAc;EAAd,iCAAc;UAAd,yBAAc;EAAd,qBAAc;EAAd,sBAAc;EAAd,6BAAc;EAAd,yBAAc;UAAd,iBAAc;EAAd,cAAc;EAAd,YAAc;EAAd,WAAc;EAAd,cAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,4CAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,wBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd,8BAAc;EAAd,8BAAc;EAAd,2BAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd;AAAc;;AAAd;EAAA,yDAAc;EAAd,8BAAc;EAAd,yBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,8BAAc;EAAd,iCAAc;UAAd;AAAc;;AAAd;EAAA,yBAAc;EAAd;AAAc;;AAAd;EAAA,iBAAc;EAAd,qBAAc;EAAd,eAAc;EAAd,gBAAc;EAAd,UAAc;EAAd,gBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,YAAc;EAAd,mBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,mBAAc;EAAd,eAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,mBAAc;EAAd,0BAAc;EAAd,uBAAc;AAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA,mBAAc;EAAd;AAAc;;AAAd;EAAA,YAAc;EAAd,mBAAc;AAAA;;AAAd;EAAA;AAAc;;AAAd;EAAA,eAAc;EAAd,cAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,4FAAc;EAAd,sBAAc;EAAd;AAAc;;AAAd;EAAA,eAAc;EAAd,cAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,SAAc;EAAd,gBAAc;EAAd,qBAAc;EAAd,wBAAc;EAAd;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,+CAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB,+QAAmB;UAAnB;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qGAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;;;AAInB;EACE,qBAAqB;EACrB,qBAAqB;EACrB,yDAAyD;EACzD,8BAA8B;EAC9B,mCAAmC;EACnC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,aAAa;AACb;;;;;;;;;;;;;;;;;;;;;;;;;;;KA2BK;;;AAGL;EACE,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,uBAAuB;EACvB,eAAe;EAEf,yBAAyB;EAEzB,iBAAiB;AACnB;;;AAGA;EACE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yDAAmD;EACnD,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,yDAAwC;EACxC,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,yDAAoE;EACpE,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,yDAAmD;EACnD,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,yDAAmD;EACnD,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE;IACE,yDAA4C;IAC5C,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,yDAAwC;IACxC,2BAA2B;IAC3B,4BAA4B;EAC9B;;AAEF;;AAEA;EACE;IACE,0DAA4C;IAC5C,2BAA2B;EAC7B;;EAEA;IACE,yDAAwC;IACxC,2BAA2B;EAC7B;AACF;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;;EAEnB;IACE,mBAAmB;IACnB,+DAA+D;IAC/D,6BAA6B;IAC7B,oCAAoC;IACpC,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;;IAEE,WAAW;IACX,8BAA8B;IAC9B,yFAAyF;IACzF,WAAW;IACX,QAAQ;IACR,kBAAkB;IAClB,kDAAkD;EACpD;;EAEA;IACE,MAAM;IACN,OAAO;IACP,WAAW;IACX,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,SAAS;IACT,QAAQ;IACR,UAAU;IACV,+BAA+B;IAC/B,gCAAgC;EAClC;;EAEA;IACE;MACE,WAAW;MACX,QAAQ;MACR,UAAU;IACZ;;IAEA;MACE,WAAW;MACX,OAAO;MACP,WAAW;IACb;;IAEA;MACE,mBAAmB;MACnB,+DAA+D;MAC/D,6BAA6B;MAC7B,oCAAoC;IACtC;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,YAAY;MACZ,aAAa;IACf;EACF;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yDAAmD;EACnD,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;;EAEZ;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,YAAY;IACZ,MAAM;IACN,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,iFAAiF;IACjF,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,wDAAwD;IAExD,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,MAAM;IACN,OAAO;IACP,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE;MACE,WAAW;MACX,QAAQ;MACR,UAAU;MACV,UAAU;MAEV,uBAAuB;IACzB;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,cAAc;MACd,UAAU;MAEV,sBAAsB;IACxB;;IAEA;MACE,YAAY;IACd;EACF;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,0DAAmD;EACnD,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;;EAEZ;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,iFAAiF;IACjF,YAAY;IACZ,QAAQ;IACR,kBAAkB;IAClB,wDAAwD;IAExD,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,MAAM;IACN,OAAO;IACP,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE;MACE,WAAW;MACX,QAAQ;MACR,UAAU;MACV,UAAU;MAEV,uBAAuB;IACzB;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,cAAc;MACd,UAAU;MAEV,sBAAsB;IACxB;;IAEA;MACE,YAAY;IACd;EACF;AACF;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,uBAAuB;EACvB,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE;IACE,WAAW;IACX,aAAa;IACb,SAAS;IACT,0DAAwE;IACxE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,aAAa;IACb,UAAU;IACV,0DAAwE;IACxE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,0DAAmD;IACnD,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;AAEF;;AAEA;EACE;IACE,sCAAsC;IACtC,oCAAoC;IACpC,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;IAC3B,yBAAyB;IACzB,4BAA4B;IAC5B,+BAA+B;;EAEjC;AACF;;AAEA;;EAEE;IACE,WAAW;IACX,aAAa;IACb,UAAU;IACV,0DAAiE;IACjE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,aAAa;IACb,QAAQ;IACR,0DAAiE;IACjE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,0DAAmD;IACnD,sBAAsB;;EAExB;;AAEF;;AAEA;;EAEE;IACE,UAAU;IACV,YAAY;IACZ,QAAQ;IACR,0DAAiE;IACjE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,UAAU;IACV,0DAAiE;IACjE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,0DAAmD;IACnD,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,0DAAmD;IACnD,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;IACZ,UAAU;IACV,0DAAiE;IACjE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,UAAU;IACV,0DAAiE;IACjE,UAAU;EACZ;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,OAAO;EACP,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,MAAM;AACR;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,sBAAsB;EACtB,kCAAkC;EAClC,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,2CAA2C;EAC3C,yDAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,sBAAsB;EACtB,kCAAkC;EAClC,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uDAAuD;EACvD,yDAAyD;EACzD,mEAAmE;EACnE,kCAAkC;EAClC,4BAA4B;EAC5B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;;;2BAGyB;EACzB;;;;;;;;;;;;;;;;;;;;;;;;;8BAyB4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,iCAAiC;EACjC,6CAA6C;EAC7C,mBAAmB;EACnB,uDAAuD;EACvD,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,8DAA8D;EAC9D,sBAAsB;AACxB;;AA3zBA;EAAA;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,wBA2zBC;EA3zBD,wDA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,4BA2zBC;EA3zBD,wDA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,eA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,eA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,wBA2zBC;EA3zBD,wDA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,8BA2zBC;EA3zBD,wDA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,8BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,iBA2zBC;EA3zBD,iBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,+EA2zBC;EA3zBD,mGA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,uCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,wCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,wCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,wCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,uCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,uCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,uCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,wCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,yCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,wCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,yCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,uCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,wCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,wCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,uCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,wCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,wCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,uCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,uCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,uCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,iBA2zBC;EA3zBD,iBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,iCA2zBC;EA3zBD,+CA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,8BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,2GA2zBC;EA3zBD,yGA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,2GA2zBC;EA3zBD,yGA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,2GA2zBC;EA3zBD,yGA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,2GA2zBC;EA3zBD,yGA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,2GA2zBC;EA3zBD,yGA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,eA2zBC;EA3zBD,eA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,iCA2zBC;EA3zBD,+CA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,4DA2zBC;EA3zBD,qEA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,iCA2zBC;EA3zBD,+CA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,8BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,2GA2zBC;EA3zBD,yGA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,qBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,eA2zBC;EA3zBD,eA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,mBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,uBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,yBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,iBA2zBC;EA3zBD,iBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,mBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,eA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,iCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,0BA2zBC;EA3zBD,uBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,6BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,2BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,oDA2zBC;EA3zBD,yDA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,sBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,oBA2zBC;EA3zBD;AA2zBC;;AA3zBD;;EAAA;IAAA,iBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,kBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,iBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,mBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,kBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,eA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,mBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,kBA2zBC;IA3zBD;EA2zBC;AAAA;;AA3zBD;;EAAA;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,iBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,mBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,iBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,kBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,gBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,uBA2zBC;IA3zBD,oDA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,8BA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,oBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,oBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,kBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,iBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,mBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,kBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,eA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,eA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,mBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,mBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,oBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,oBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,oBA2zBC;IA3zBD;EA2zBC;AAAA;;AA3zBD;;EAAA;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,gBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,oBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,kBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,kBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,mBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,iBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,oBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,iBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,kBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,eA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,mBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;AAAA;;AA3zBD;;EAAA;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,oBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,kBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,kBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,oBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,mBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,eA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,kBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;AAAA;;AA3zBD;;EAAA;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA,iBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,eA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,kBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA,iBA2zBC;IA3zBD;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;AAAA;;AA3zBD;;EAAA;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;;EA3zBD;IAAA;EA2zBC;AAAA;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,2GA2zBC;EA3zBD,yGA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,kBA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,2GA2zBC;EA3zBD,yGA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA,8BA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA,kCA2zBC;EA3zBD;AA2zBC;;AA3zBD;EAAA;AA2zBC;;AA3zBD;EAAA;AA2zBC","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n\n\n:root {\n  --color--white: white;\n  --color--black: black;\n  --typegraphy--brand-font-family: general-sans, sans-serif;\n  --color--primary-blue: #4297f7;\n  --color--primary-green-500: #40b792;\n  --layout--max-width: 1600px;\n  --layout--container-inner-padding: 200px;\n}\n\n/* homepage */\n/* .background-image {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n    filter: brightness(60%);\n  }\n\n  #Home {\n    position: relative;\n  }\n\n  @media (min-width: 1024px) {\n    .background-image {\n      background-image: url(./assets/bgLarge.jpg);\n      background-attachment: fixed;\n    }\n  }\n\n  @media (max-width: 1023px) {\n    .background-image {\n      background-image: url(./assets/bgSmall.jpg);\n    }\n  } */\n\n\n#Home {\n  position: relative;\n}\n\n/* prevent image to be dragable */\n.selector {\n  -webkit-user-drag: none;\n  user-drag: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n\n::-webkit-scrollbar {\n  width: 5px;\n  background-color: #161616;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #ceae7b;\n  border-radius: 10px;\n}\n\n.background-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  min-height: 100vh;\n  background-repeat: no-repeat;\n  background-size: cover;\n  filter: brightness(60%);\n}\n\n.background-image-1 {\n  background-image: url(./assets/bg/bg-section-2.png);\n  background-position: center;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.background-image-2 {\n  background-image: url(./assets/bg/4.png);\n  background-position: center;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.background-image-3 {\n  background-image: url(./assets/section-asset/asset-gif-3-mobile.gif);\n  background-position: center;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.background-image-4 {\n  background-image: url(./assets/bg/bg-section-5.png);\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.background-image-5 {\n  background-image: url(./assets/bg/bg-section-6.png);\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n@media (min-width: 1024px) {\n  .background-image {\n    background-image: url(./assets/laptopBG.png);\n    background-position: center;\n    background-attachment: fixed;\n  }\n\n  .background-image-2 {\n    background-image: url(./assets/bg/4.png);\n    background-position: center;\n    background-attachment: fixed;\n  }\n\n}\n\n@media (max-width: 1023px) {\n  .background-image {\n    background-image: url(./assets/mobileBG.png);\n    background-position: center;\n  }\n\n  .background-image-2 {\n    background-image: url(./assets/bg/4.png);\n    background-position: center;\n  }\n}\n\n.line-why-codos-section {\n  background-color: #d9d9d9;\n  width: 1px;\n  height: calc(100% - 20px);\n  position: absolute;\n  left: 50px;\n}\n\n.line-pointer-why-codos-section {\n  background-color: #d9d9d9;\n  width: 6px;\n  height: 1px;\n  position: absolute;\n  inset: 0% auto auto 0%;\n}\n\n.content-card {\n  border: 1px solid #ffffff47;\n  border-radius: 10px;\n  padding: 40px 40px;\n  justify-content: center;\n  transform: translate(-0%, -0%);\n  margin-bottom: 15px;\n\n  .number-metric-display-button {\n    background: #F7D091;\n    background: linear-gradient(to right, #F7D091 0%, #917A55 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    color: #3330;\n    margin-bottom: 0;\n    font-weight: 700;\n    line-height: 100%;\n    z-index: 9999;\n    transform-origin: center left;\n    transition: color 0.3s ease;\n  }\n\n  .headline-content {\n    z-index: 9999;\n    transform-origin: center left;\n    transition: color 0.3s ease;\n  }\n\n  &:before,\n  &:after {\n    content: '';\n    background: rgb(247, 208, 145);\n    background: linear-gradient(90deg, rgba(247, 208, 145, 1) 0%, rgba(145, 122, 85, 1) 100%);\n    height: 50%;\n    width: 0;\n    position: absolute;\n    transition: .3s cubic-bezier(.785, .135, .15, .86);\n  }\n\n  &:before {\n    top: 0;\n    left: 0;\n    right: auto;\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n  }\n\n  &:after {\n    bottom: 0;\n    right: 0;\n    left: auto;\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n  }\n\n  &:hover {\n    &:before {\n      width: 100%;\n      right: 0;\n      left: auto;\n    }\n\n    &:after {\n      width: 100%;\n      left: 0;\n      right: auto;\n    }\n\n    .number-metric-display-button {\n      background: #151515;\n      background: linear-gradient(to right, #444444 0%, #151515 100%);\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n    }\n\n    .headline-content {\n      color: #121212;\n    }\n\n    .content-card {\n      border: none;\n      z-index: 9999;\n    }\n  }\n}\n\n.content-card-1 {\n  border: 1px solid #ceae7b;\n  border-radius: 10px;\n  padding: 40px 40px;\n  justify-content: center;\n  transform: translate(-0%, -0%);\n  margin-bottom: 15px;\n  position: relative;\n  overflow: hidden;\n  background-image: url(./assets/bg/bg-section-2.png);\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100%;\n\n  .number-metric-display-button {\n    color: #161616;\n    margin-bottom: 0;\n    font-weight: 600;\n    transform-origin: center left;\n    opacity: 1;\n  }\n\n  .headline-content {\n    z-index: 9999;\n    transform-origin: center left;\n    position: absolute;\n    opacity: 0;\n    color: #161616;\n    height: 100%;\n    top: 0;\n    bottom: 0;\n  }\n\n  &:before {\n    content: '';\n    background: rgb(247, 208, 145);\n    background: linear-gradient(90deg, rgb(247, 208, 145) 0%, rgb(145, 122, 85) 100%);\n    height: 100%;\n    width: 0;\n    position: absolute;\n    /* transition: .3s cubic-bezier(.785, .135, .15, .86); */\n    -webkit-transition: all 0.4s ease;\n    transition: all 0.4s ease;\n    opacity: 0;\n  }\n\n  &:before {\n    top: 0;\n    left: 0;\n    right: auto;\n    border-radius: 10px;\n  }\n\n  &:hover {\n    &:before {\n      width: 100%;\n      right: 0;\n      left: auto;\n      opacity: 1;\n      -webkit-transition-delay: 0.25s;\n      transition-delay: 0.25s;\n    }\n\n    .number-metric-display-button {\n      opacity: 0;\n    }\n\n    .headline-content {\n      color: #161616;\n      opacity: 1;\n      -webkit-transition-delay: 0.6s;\n      transition-delay: 0.6s;\n    }\n\n    .content-card {\n      border: none;\n    }\n  }\n}\n\n.content-card-2 {\n  border: 1px solid #ceae7b;\n  border-radius: 10px;\n  padding: 40px 40px;\n  justify-content: center;\n  transform: translate(-0%, -0%);\n  margin-bottom: 15px;\n  position: relative;\n  overflow: hidden;\n  background-image: url(./assets/bg/bg-section-3.png);\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 100%;\n\n  .number-metric-display-button {\n    color: #161616;\n    margin-bottom: 0;\n    font-weight: 600;\n    transform-origin: center left;\n    opacity: 1;\n  }\n\n  .headline-content {\n    z-index: 9999;\n    transform-origin: center left;\n    position: absolute;\n    opacity: 0;\n    color: #161616;\n    text-align: center;\n  }\n\n  &:before {\n    content: '';\n    background: rgb(247, 208, 145);\n    background: linear-gradient(90deg, rgb(247, 208, 145) 0%, rgb(145, 122, 85) 100%);\n    height: 100%;\n    width: 0;\n    position: absolute;\n    /* transition: .3s cubic-bezier(.785, .135, .15, .86); */\n    -webkit-transition: all 0.4s ease;\n    transition: all 0.4s ease;\n    opacity: 0;\n  }\n\n  &:before {\n    top: 0;\n    left: 0;\n    right: auto;\n    border-radius: 10px;\n  }\n\n  &:hover {\n    &:before {\n      width: 100%;\n      right: 0;\n      left: auto;\n      opacity: 1;\n      -webkit-transition-delay: 0.25s;\n      transition-delay: 0.25s;\n    }\n\n    .number-metric-display-button {\n      opacity: 0;\n    }\n\n    .headline-content {\n      color: #161616;\n      opacity: 1;\n      -webkit-transition-delay: 0.6s;\n      transition-delay: 0.6s;\n    }\n\n    .content-card {\n      border: none;\n    }\n  }\n}\n\n.word-animation {\n  display: inline-block;\n}\n\n\n.letter {\n  display: inline-block;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n}\n\n.letter.in {\n  opacity: 1;\n  transform: rotateY(0deg);\n}\n\n.letter.out {\n  opacity: 0;\n  transform: rotateY(-90deg);\n}\n\n.letter.behind {\n  opacity: 0;\n  transform: rotateY(-90deg);\n}\n\n.benefits-section-bg {\n  pointer-events: none;\n  justify-content: flex-end;\n  align-items: flex-start;\n  display: flex;\n  position: absolute;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.benefits-section-bg-1 {\n  pointer-events: none;\n  justify-content: flex-start;\n  align-items: flex-start;\n  display: flex;\n  position: absolute;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  right: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.benefits-section-bg-2 {\n  pointer-events: none;\n  justify-content: flex-start;\n  align-items: flex-start;\n  display: flex;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  width: 100%;\n  height: 100%;\n}\n\n.transition-animation {\n  display: none;\n}\n\n@media only screen and (max-width: 767px) and (min-width: 320px) {\n\n  .benefits-section-bg {\n    width: 100%;\n    height: 100vh;\n    top: -0px;\n    background-image: url(./assets/section-asset/asset-section-4-mobile.png);\n    filter: brightness(30%);\n    z-index: -1;\n  }\n\n  .benefits-section-bg-1 {\n    width: 100%;\n    height: 100vh;\n    top: -10px;\n    background-image: url(./assets/section-asset/asset-section-5-mobile.png);\n    filter: brightness(30%);\n    z-index: -1;\n  }\n\n  .benefits-section-bg-2.bg_img {\n    width: 100%;\n    height: 100%;\n    top: 0px;\n    background-image: url(./assets/bg/bg-section-8.png);\n    background-size: cover;\n    opacity: 20%;\n  }\n\n  .word-animation {\n    display: none;\n  }\n\n  .transition-animation {\n    display: inline-block;\n  }\n\n}\n\n@media only screen and (max-width: 768px) and (min-width: 320px) {\n  header {\n    transition: background-color 0.3s ease;\n    transition: padding-bottom 0.3s ease;\n    transition: padding-top 0.3s ease;\n  }\n\n  header.scrolled {\n    background-color: #1e1e1ef2;\n    /* New background color */\n    padding-top: 10px !important;\n    padding-bottom: 10px !important;\n\n  }\n}\n\n@media only screen and (max-width: 1024px) and (min-width: 768px) {\n\n  .benefits-section-bg {\n    width: 100%;\n    height: 100vh;\n    top: -10px;\n    background-image: url(./assets/section-asset/asset-section-4.png);\n    filter: brightness(30%);\n    z-index: -1;\n  }\n\n  .benefits-section-bg-1 {\n    width: 100%;\n    height: 100vh;\n    top: 0px;\n    background-image: url(./assets/section-asset/asset-section-5.png);\n    filter: brightness(30%);\n    z-index: -1;\n  }\n\n  .benefits-section-bg-2.bg_img {\n    width: 100%;\n    height: 100%;\n    top: 0px;\n    background-image: url(./assets/bg/bg-section-8.png);\n    background-size: cover;\n\n  }\n\n}\n\n@media only screen and (max-width: 2560px) and (min-width: 1440px) {\n\n  .benefits-section-bg {\n    width: 60%;\n    height: 100%;\n    top: 0px;\n    background-image: url(./assets/section-asset/asset-section-4.png);\n    bottom: 0;\n    z-index: 1;\n  }\n\n  .benefits-section-bg-1 {\n    width: 70%;\n    height: 100%;\n    top: -20px;\n    background-image: url(./assets/section-asset/asset-section-5.png);\n    bottom: 0;\n    z-index: 1;\n  }\n\n  .number-metric-display-button {\n    font-size: 4rem;\n  }\n\n  .benefits-section-bg-2.bg_img {\n    width: 100%;\n    height: 100%;\n    top: 0px;\n    background-image: url(./assets/bg/bg-section-8.png);\n    background-size: cover;\n  }\n}\n\n@media only screen and (max-width: 1439px) and (min-width: 1025px) {\n  .benefits-section-bg-2.bg_img {\n    width: 100%;\n    height: 100%;\n    background-image: url(./assets/bg/bg-section-8.png);\n    background-size: cover;\n  }\n}\n\n@media only screen and (max-width: 1439px) and (min-width: 1026px) {\n  .benefits-section-bg {\n    width: 65%;\n    height: 100%;\n    top: -90px;\n    background-image: url(./assets/section-asset/asset-section-4.png);\n    z-index: 1;\n  }\n\n  .benefits-section-bg-1 {\n    width: 85%;\n    height: 100%;\n    top: -90px;\n    background-image: url(./assets/section-asset/asset-section-5.png);\n    z-index: 1;\n  }\n}\n\n.wrapper {\n  transform: translate(-0%, -0%);\n}\n\n.btn-apply {\n  display: block;\n  text-decoration: none;\n  text-align: center;\n  border-radius: 50px;\n  border: 3px solid #ceae7b;\n  color: #ceae7b;\n  font-family: arial;\n  position: relative;\n  overflow: hidden;\n  background: transparent;\n  text-transform: uppercase;\n  transition: all .35s;\n  padding: 10px 20px;\n}\n\n.btn-apply:before,\n.btn-apply:after {\n  position: absolute;\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  top: -100%;\n  left: 0;\n  background: #ceae7b;\n  z-index: -1;\n  transition: all .35s;\n}\n\n.btn-apply:before {\n  opacity: .5;\n}\n\n.btn-apply:after {\n  transition-delay: .2s;\n}\n\n.btn-apply:hover {\n  color: #161616;\n  border: 0px solid #ceae7b;\n  font-weight: 600;\n}\n\n.btn-apply:hover:before,\n.btn-apply:hover:after {\n  top: 0;\n}\n\n.content {\n  height: 100vh;\n}\n\n.text-content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  padding: 5px 15px;\n  transform: translate(-50%, -50%);\n  background: gray;\n  color: white;\n  border-radius: 20px;\n  font-size: 50px;\n}\n\n.parallax_section {\n  padding: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.parallax_bg {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  z-index: -1;\n  min-height: 100%;\n  transform: translate3d(0, 0, -1px) scale(2);\n  background-image: url(./assets/bg/4.png);\n}\n\n.parallax_bg_1 {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n  z-index: -1;\n  min-height: 100%;\n  width: 100%;\n  height: 100%;\n}\n\n.parallax_bg_1.parallax_img {\n  /* background-image: url(./assets/New-Xure-Logo.png); */\n  /* background-image: url(./assets/bg/bg-section-7.png); */\n  /* background-image: url(./assets/section-asset/asset-gif-3.mp4); */\n  background-position: center center;\n  background-repeat: no-repeat;\n  opacity: 20%;\n  filter: blur(5px);\n}\n\n.swipe-section {\n  position: relative;\n  overflow: hidden;\n}\n\n.panel {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 2rem;\n}\n\n#mobile-nav {\n  /* background-image: url(./assets/bg/bg-nav.png);\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover; */\n  background-image: linear-gradient(135deg,\n      hsl(0deg 0% 2%) 12%,\n      hsl(37deg 25% 13%) 63%,\n      hsl(37deg 25% 19%) 74%,\n      hsl(37deg 25% 23%) 80%,\n      hsl(37deg 25% 26%) 84%,\n      hsl(37deg 25% 30%) 88%,\n      hsl(37deg 25% 32%) 90%,\n      hsl(37deg 25% 35%) 92%,\n      hsl(37deg 25% 37%) 94%,\n      hsl(37deg 25% 40%) 95%,\n      hsl(37deg 25% 42%) 96%,\n      hsl(37deg 25% 44%) 97%,\n      hsl(37deg 25% 46%) 98%,\n      hsl(37deg 25% 48%) 99%,\n      hsl(37deg 25% 49%) 99%,\n      hsl(37deg 26% 51%) 100%,\n      hsl(37deg 28% 53%) 100%,\n      hsl(37deg 30% 54%) 100%,\n      hsl(37deg 32% 56%) 100%,\n      hsl(37deg 34% 57%) 100%,\n      hsl(37deg 36% 59%) 100%,\n      hsl(37deg 38% 60%) 100%,\n      hsl(37deg 41% 62%) 100%,\n      hsl(37deg 43% 63%) 100%,\n      hsl(37deg 46% 65%) 100%);\n}\n\n.fade-in {\n  animation: fadeIn 0.7s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n#loader-container {\n  max-width: 100%;\n  position: absolute;\n  height: 100%;\n  background-color: #161616;\n}\n\n.dialog-body-scroll {\n  max-height: calc(90vh - 100px);\n  /* Adjust to your needs */\n  overflow-y: scroll;\n  /* Always show a scrollbar */\n  -webkit-overflow-scrolling: touch;\n  /* Enable smooth scrolling on touch devices */\n  touch-action: pan-y;\n  /* Ensures smooth vertical scrolling on touch devices */\n  scroll-behavior: smooth;\n  /* Smooth scrolling */\n  position: relative;\n  /* Helps ensure the element is scrollable */\n  display: flex;\n  /* Ensures proper internal layout for the scrollable content */\n  flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
